import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import user_service from "../service/user_service";
import ReactPaginate from "react-paginate";
import Loader from "../../Pages/Loader/Loader.js";
import Toaster from "../../Pages/Toaster/Toaster.js";
import avtar from "../img/avtar.jpg";
import AllTab from "../../Pages/AllTab";
import jwt from "jwt-decode";
import _ from "lodash";
import Pic from "../img/pic.png";
import defaultpropertyimage from "../../Components/img/defaultpropertyimage.jpeg";
// import StatusBar from "../../Pages/StatusBar.js";

const TransactionContact = () => {
  const navigate = useNavigate();
  const initialValues = {
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    agentId: "",
    nickname: "",
    contactType: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitClick, setISSubmitClick] = useState(false);
  const [isSubmitClickNew, setISSubmitClickNew] = useState(false);

  const [clientId, setClientId] = useState("");
  const [select, setSelect] = useState("");

  const [transactionId, setTransactionId] = useState([]);
  const [results, setResults] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState({ isActive: null });
  const { isActive } = loader;
  const [toaster, setToaster] = useState({
    types: null,
    isShow: null,
    toasterBody: "",
    message: "",
  });
  const { types, isShow, toasterBody, message } = toaster;
  const [summary, setSummary] = useState([]);
  const [arrayData, setArrayData] = useState([]);
  const params = useParams();
  const [contactTitle, setContactTitle] = useState("");
  const [step1, setStep1] = useState("");
  const [step2, setStep2] = useState("");
  const [type, setType] = useState("");
  const [step3, setStep3] = useState("");
  const [phase, setPhase] = useState("");
  const [step4, setStep4] = useState("");
  const [represent, setRepresent] = useState("");
  const [step5, setStep5] = useState("");
  const [contact, setContact] = useState("");
  const [step6, setStep6] = useState("");
  const [contactValue, setContactValue] = useState("");

  const [step7, setStep7] = useState("");
  const [contactNew, setContactNew] = useState("");
  const [step8, setStep8] = useState("");
  const [contactVendor, setContactVendor] = useState("");
  const [step9, setStep9] = useState("");
  const [contactPartner, setContactPartner] = useState("");
  const [step10, setStep10] = useState("");
  const [contactHome, setContactHome] = useState("");

  const [step11, setStep11] = useState("");
  const [contactLender, setContactLender] = useState("");

  const [step12, setStep12] = useState("");
  const [contactSellerOther, setContactSellerOther] = useState("");

  const [step13, setStep13] = useState("");
  const [contactBuyerOther, setContactBuyerOther] = useState("");

  const [popupPhase, setPopupPhase] = useState(false);
  const [popup, setPopup] = useState(false);
  const [popupRepresent, setPopupRepresent] = useState(false);
  const [popupContact, setPopupContact] = useState(false);
  const [popupContactAttoney, setPopupContactAttoney] = useState(false);
  const [popupContactVendor, setPopupContactVendor] = useState(false);
  const [popupContactPartner, setPopupContactPartner] = useState(false);
  const [popupContactHome, setPopupContactHome] = useState(false);
  const [popupLender, setPopupLender] = useState(false);

  const [popupSellerOther, setPopupSellerOther] = useState(false);
  const [popupBuyerOther, setPopupBuyerOther] = useState(false);



  const [addUserConfirmation, setAddUserConfirmation] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupValue, setPopupValue] = useState(false);

  const [addContact, setAddContact] = useState("");

  const [checkBox, setSetCheckbox] = useState(false);

  const [getrequireddoucmentno, setGetrequireddoucmentno] = useState([]);

  const [transactionFundingRequest, setTransactionFundingRequest] =
    useState("");

  const TransactionFundingRequest = async () => {
    await user_service.transactionFundingRequest(params.id).then((response) => {
      if (response) {
        setTransactionFundingRequest(response.data.data[0]);
      }
    });
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoader({ isActive: true });
        await Promise.all([
          TransactionFundingRequest(params.id),
          TransactionGetById(params.id),
          Getrequireddoucmentno(),
        ]);
      } catch (error) {
        console.error("Error in fetching data:", error);
        setLoader({ isActive: false });
      } finally {
        setLoader({ isActive: false });
      }
    };
  
    fetchData();
  }, [params.id]);

  const Getrequireddoucmentno = async () => {
    const agentId = jwt(localStorage.getItem("auth")).id;
    await user_service
      .Getrequireddoucmentno(agentId, params.id)
      .then((response) => {
        // setLoader({ isActive: false });
        if (response) {
          //  console.log(response.data)
          setGetrequireddoucmentno(response.data);
        }
      });
  };

  const handleCheck = () => {
    setSetCheckbox(checkBox ? true : false);
  };

  {
    /* <!-- Input onChange Start--> */
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  {
    /* <!-- Input onChange End--> */
  }

  {
    /* <!-- Form Validation Start--> */
  }
  useEffect(() => {
    if (formValues && isSubmitClick) {
      validate();
      // SearchGetAll(0)
    }
  }, [formValues]);

  const validate = () => {
    const values = formValues;
    const errors = {};
    if (!values.firstName) {
      errors.firstName = "name is required";
    }

    if (!values.lastName) {
      errors.lastName = "lastName is required";
    }

    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    // if (!values.email) {
    //   errors.email = "email is required";
    // } else if (
    //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    // ) {
    //   errors.email = "Invalid email address";
    // }

    setFormErrors(errors);
    return errors;
  };
  {
    /* <!-- Form Validation End--> */
  }

  const handleNewContact = async (e, id) => {
    e.preventDefault();
    setISSubmitClick(true);
    let checkValue = validate();
    if (_.isEmpty(checkValue)) {
      const userData = {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        nickname: formValues.lastName + "" + formValues.firstName,
        contactType: "private",
        company: formValues.company,
        email: formValues.email,
        phone: formValues.phone,
        agentId: jwt(localStorage.getItem("auth")).id,
      };
      try {
        setLoader({ isActive: true });
        const response = await user_service.contact(
          userData,
          formValues.firstName,
          id
        );
        const contactData = response.data;
        setSummary((prevSummary) => [...prevSummary, contactData]);
        setArrayData((prevArrayData) => [...prevArrayData, contactData._id]);
        setSelect(response.data);
        setClientId(id);

        // const userDatan = {
        //   addedBy: jwt(localStorage.getItem("auth")).id,
        //   agentId: jwt(localStorage.getItem("auth")).id,
        //   transactionId: params.id,
        //   message: "Transaction Contact Update",
        //   // transaction_property_address: "ADDRESS 2",
        //   note_type: "Contact Update"
        // };
        // const responsen = await user_service.transactionNotes(userDatan);

        setLoader({ isActive: false });
        setToaster({
          type: "Contact Added Successfully",
          isShow: true,
          // toasterBody: response.data.message,
          message: "Contact Added Successfully",
        });
        setTimeout(() => {
          setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
        }, 2000);

        setAddUserConfirmation(false);
      } catch (error) {
        setLoader({ isActive: false });
        setToaster({
          type: "API Error",
          isShow: true,
          // toasterBody: error.response.data.message,
          message: "API Error",
        });

        setTimeout(() => {
          setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
        }, 2000);
      }
    }
  };
  {
    /* <!-- Api call Form onSubmit End--> */
  }

  useEffect(() => {
    if (formValues && isSubmitClickNew) {
      validateNew();
    }
  }, [formValues]);

  const validateNew = () => {
    const values = formValues;
    const errors = {};
    if (!values.firstName) {
      errors.firstName = "name is required";
    }

    if (!values.lastName) {
      errors.lastName = "lastName is required";
    }

    setFormErrors(errors);
    return errors;
  };

  const handleContactRightPopup = async (e, id) => {
    e.preventDefault();
    setISSubmitClickNew(true);
    let checkValue = validateNew();
    if (_.isEmpty(checkValue)) {
      const userData = {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        company: formValues.company,
        nickname: formValues.lastName + "" + formValues.firstName,
        contactType: "private",
        email: formValues.email,
        phone: formValues.phone,
        agentId: jwt(localStorage.getItem("auth")).id,
      };
      try {
        setLoader({ isActive: true });
        const response = await user_service.contact(
          userData,
          formValues.firstName,
          id
        );
        const contactData = response.data;
        setSummary((prevSummary) => [...prevSummary, contactData]);
        setArrayData((prevArrayData) => [...prevArrayData, contactData._id]);
        setSelect(response.data);
        setClientId(id);

        setLoader({ isActive: false });
        setToaster({
          type: "Contact Added Successfully",
          isShow: true,
          // toasterBody: response.data.message,
          message: "Contact Added Successfully",
        });
        setTimeout(() => {
          setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
        }, 2000);

        setAddUserConfirmation(false);
      } catch (error) {
        setLoader({ isActive: false });
        setToaster({
          type: "API Error",
          isShow: true,
          // toasterBody: error.response.data.message,
          message: "API Error",
        });

        setTimeout(() => {
          setToaster({
            types: "error",
            isShow: false,
            toasterBody: null,
            message: "Error",
          });
        }, 2000);
      }
    }
  };




  const TransactionGetById = async () => {
    setLoader({ isActive: true });
    await user_service.transactionGetById(params.id).then((response) => {
      if (response) {
        // setLoader({ isActive: false });
        console.log(response.data);
        setTransactionId(response.data);
      }
    });
  };

  const TransactionEdit = (type, id) => {
    if (type === "private") {
      navigate(`/private-contact/${id}`);
    } else {
      navigate(`/contact-profile/${id}`);
    }
  };

  const handleCancel = (id) => {
    setShowPopup(false);
    setPopupPhase(false);
    setPopup(false);
    setPopupContact(false);
    setPopupContactAttoney(false);
    setPopupContactVendor(false);
    setPopupContactPartner(false);
    setPopupContactHome(false);
    setPopupLender(false);

    setPopupRepresent(false);
    setPopupValue(false);
    setPopupSellerOther(false)
    setPopupBuyerOther(false)
    //  console.log("Contact deletion canceled");
  };

  const selectContact = async () => {
    let arr = [];
    let array = [];
    let arrsellerAgent = [];
    let arrbuyerAgent = [];
    let arrCoordinator = [];
    let arrVendor = [];
    let arrAttorney = [];
    let arrVendorNew = [];
    let arrPartner = [];
    let arrHome = [];
    let arrLender = [];
    let arrOther= [];
    let arrBuyerOther= [];
  
    if (transactionId.represent === "seller") {
      transactionId.contact1.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          arr.push(contact);
        }
      });
      if (represent === "seller") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }
  
      transactionId.contact2.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          array.push(contactbuyer);
        }
      });
      if (type === "buyer") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }
  
      transactionId.contact3.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrsellerAgent.push(contactsellerAgent);
        }
      });
      if (phase === "seller_Agent") {
        const newUserseller = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserseller);
      }
  
      transactionId.contact4.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrbuyerAgent.push(contactbuyerAgent);
        }
      });
  
      if (represent === "buyer_Agent") {
        const newUserbuyer = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserbuyer);
      }
  
      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }
  
      transactionId.contact6.map((vendorSeller) => {
        if (vendorSeller) {
          const contactSeller = {
            type: vendorSeller.data.type,
            contactId: vendorSeller.data._id,
          };
          arrVendor.push(contactSeller);
        }
      });
      if (contactValue === "seller_Title") {
        const newSellerTitle = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newSellerTitle);
      }
  
      transactionId.contact7.map((attorneySeller) => {
        if (attorneySeller) {
          const contactAttorneySeller = {
            type: attorneySeller.data.type,
            contactId: attorneySeller.data._id,
          };
          arrAttorney.push(contactAttorneySeller);
        }
      });
      if (contactNew === "seller_Attorney") {
        const newAttorneySeller = {
          type: contactNew,
          contactId: select._id,
        };
        arrAttorney.push(newAttorneySeller);
      }
  
      transactionId.contact8.map((VendorSeller) => {
        if (VendorSeller) {
          const contactVendorSeller = {
            type: VendorSeller.data.type,
            contactId: VendorSeller.data._id,
          };
          arrVendorNew.push(contactVendorSeller);
        }
      });
      if (contactVendor === "vendorNew") {
        const newVendorSeller = {
          type: contactVendor,
          contactId: select._id,
        };
        arrVendorNew.push(newVendorSeller);
      }
  
      transactionId.contact9.map((partnerSeller) => {
        if (partnerSeller) {
          const contactpartnerSeller = {
            type: partnerSeller.data.type,
            contactId: partnerSeller.data._id,
          };
          arrPartner.push(contactpartnerSeller);
        }
      });
      if (contactPartner === "seller_partner") {
        const newPartnerSeller = {
          type: contactPartner,
          contactId: select._id,
        };
        arrPartner.push(newPartnerSeller);
      }
  
      transactionId.contact10.map((homeSeller) => {
        if (homeSeller) {
          const contacthomerSeller = {
            type: homeSeller.data.type,
            contactId: homeSeller.data._id,
          };
          arrHome.push(contacthomerSeller);
        }
      });
      if (contactHome === "home_Warrenty") {
        const newHomeSeller = {
          type: contactHome,
          contactId: select._id,
        };
        arrHome.push(newHomeSeller);
      }
      
  
      transactionId.contact11.map((lenderSeller) => {
        if (lenderSeller) {
          const contactLenderSeller = {
            type: lenderSeller.data.type,
            contactId: lenderSeller.data._id,
          };
          arrLender.push(contactLenderSeller);
        }
      });
      if (contactLender === "buyer_lender") {
        const newLenderSeller = {
          type: contactLender,
          contactId: select._id,
        };
        arrLender.push(newLenderSeller);
      }
    
  
    transactionId.contact12.map((otherSeller) => {
      if (otherSeller) {
        const contactSellerOther = {
          type: otherSeller.data.type,
          name_other: otherSeller.data.name_other,
          contactId: otherSeller.data._id,
        };
        arrOther.push(contactSellerOther);
      }
    });
    if (contactSellerOther === "seller_other") {
      const newSellerOther = {
        type: contactSellerOther,
        name_other: otherSideValue,
        contactId: select._id,
      };
      arrOther.push(newSellerOther);
    }
  
  
    transactionId.contact13.map((otherBuyer) => {
      if (otherBuyer) {
        const contactBuyerOther = {
          type: otherBuyer.data.type,
          name_other: otherBuyer.data.name_other,
          contactId: otherBuyer.data._id,
        };
        arrBuyerOther.push(contactBuyerOther);
      }
    });
    if (contactBuyerOther === "other_buyer") {
      const newBuyerOther = {
        type: contactBuyerOther,
        name_other: otherSideBuyer,
        contactId: select._id,
      };
      arrBuyerOther.push(newBuyerOther);
    }
    
    }
    
    else if (transactionId.represent === "buyer") {
  
      transactionId.contact1.forEach((post) => {
        if (post) {
          arr.push({
            type: post.data.type,
            contactId: post.data._id,
          });
        }
      });
  
      if (represent === "buyer") {
        arr.push({
          type: represent,
          contactId: select._id,
        });
      }
  
      // transactionId.contact1.map((post) => {
      //   if (post) {
      //     const contactbuyer = {
      //       type: post.data.type,
      //       contactId: post.data._id,
      //     };
      //     arr.push(contactbuyer);
      //   }
      // });
  
      // if (represent === "buyer") {
      //   const newuser = {
      //     type: represent,
      //     contactId: select._id,
      //   };
      //   arr.push(newuser);
      // }
  
      // transactionId.contact2.map((item) => {
      //   if (item) {
      //     const contact = {
      //       type: item.data.type,
      //       contactId: item.data._id,
      //     };
      //     array.push(contact);
      //   }
      // });
  
      // if (type === "seller") {
      //   const newuser = {
      //     type: type,
      //     contactId: select._id,
      //   };
      //   array.push(newuser);
      // }
  
      // transactionId.contact3.map((itemData) => {
      //   if (itemData) {
      //     const contactbuyerAgent = {
      //       type: itemData.data.type,
      //       contactId: itemData.data._id,
      //     };
      //     arrsellerAgent.push(contactbuyerAgent);
      //   }
      // });
  
      // if (phase === "buyer_Agent") {
      //   const newUserbuyer = {
      //     type: phase,
      //     contactId: select._id,
      //   };
      //   arrsellerAgent.push(newUserbuyer);
      // }
  
      transactionId.contact2.forEach((item) => {
        if (item) {
          array.push({
            type: item.data.type,
            contactId: item.data._id,
          });
        }
      });
  
      if (type === "seller") {
        array.push({
          type: type,
          contactId: select._id,
        });
      }
  
      // Process contact3
      transactionId.contact3.forEach((itemData) => {
        if (itemData) {
          arrsellerAgent.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (phase === "buyer_Agent") {
        arrsellerAgent.push({
          type: phase,
          contactId: select._id,
        });
      }
  
      transactionId.contact4.forEach((itemData) => {
        if (itemData) {
          arrbuyerAgent.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (represent === "seller_Agent") {
        arrbuyerAgent.push({
          type: represent,
          contactId: select._id,
        });
      }
  
  
      // transactionId.contact4.map((postData) => {
      //   if (postData) {
      //     const contactsellerAgent = {
      //       type: postData.data.type,
      //       contactId: postData.data._id,
      //     };
      //     arrbuyerAgent.push(contactsellerAgent);
      //   }
      // });
      // if (represent === "seller_Agent") {
      //   const newUserseller = {
      //     type: represent,
      //     contactId: select._id,
      //   };
      //   arrbuyerAgent.push(newUserseller);
      // }
  
  
      transactionId.contact5.forEach((itemData) => {
        if (itemData) {
          arrCoordinator.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contact === "Coordinator") {
        arrCoordinator.push({
          type: contact,
          contactId: select._id,
        });
      }
  
      // transactionId.contact5.map((coordinator) => {
      //   if (coordinator) {
      //     const contactCoordinator = {
      //       type: coordinator.data.type,
      //       contactId: coordinator.data._id,
      //     };
      //     arrCoordinator.push(contactCoordinator);
      //   }
      // });
      // if (contact === "Coordinator") {
      //   const newuserCoordinator = {
      //     type: contact,
      //     contactId: select._id,
      //   };
      //   arrCoordinator.push(newuserCoordinator);
      // }
  
      transactionId.contact6.forEach((itemData) => {
        if (itemData) {
          arrVendor.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactValue === "buyer_Title") {
        arrVendor.push({
          type: contactValue,
          contactId: select._id,
        });
      }
  
      // transactionId.contact6.map((vendorBuyer) => {
      //   if (vendorBuyer) {
      //     const contactBuyer = {
      //       type: vendorBuyer.data.type,
      //       contactId: vendorBuyer.data._id,
      //     };
      //     arrVendor.push(contactBuyer);
      //   }
      // });
      // if (contactValue === "buyer_Title") {
      //   const newuserBuyer = {
      //     type: contactValue,
      //     contactId: select._id,
      //   };
      //   arrVendor.push(newuserBuyer);
      // }
  
  
      transactionId.contact7.forEach((itemData) => {
        if (itemData) {
          arrAttorney.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactNew === "buyer_Attorney") {
        arrAttorney.push({
          type: contactNew,
          contactId: select._id,
        });
      }
     
  
  
  
      // transactionId.contact7.map((attorneyBuyer) => {
      //   if (attorneyBuyer) {
      //     const contactAttorneyBuyer = {
      //       type: attorneyBuyer.data.type,
      //       contactId: attorneyBuyer.data._id,
      //     };
      //     arrAttorney.push(contactAttorneyBuyer);
      //   }
      // });
      // if (contactNew === "buyer_Attorney") {
      //   const newAttorneyBuyer = {
      //     type: contactNew,
      //     contactId: select._id,
      //   };
      //   arrAttorney.push(newAttorneyBuyer);
      // }
  
      transactionId.contact8.forEach((itemData) => {
        if (itemData) {
          arrVendorNew.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactVendor === "vendorNew") {
        arrVendorNew.push({
          type: contactVendor,
          contactId: select._id,
        });
      }
  
      // transactionId.contact8.map((VendorSeller) => {
      //   if (VendorSeller) {
      //     const contactVendorSeller = {
      //       type: VendorSeller.data.type,
      //       contactId: VendorSeller.data._id,
      //     };
      //     arrVendorNew.push(contactVendorSeller);
      //   }
      // });
      // if (contactVendor === "vendorNew") {
      //   const newVendorSeller = {
      //     type: contactVendor,
      //     contactId: select._id,
      //   };
      //   arrVendorNew.push(newVendorSeller);
      // }
  
      transactionId.contact9.forEach((itemData) => {
        if (itemData) {
          arrPartner.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactPartner === "buyer_partner") {
        arrPartner.push({
          type: contactPartner,
          contactId: select._id,
        });
      }
  
      // transactionId.contact9.map((partnerSeller) => {
      //   if (partnerSeller) {
      //     const contactpartnerSeller = {
      //       type: partnerSeller.data.type,
      //       contactId: partnerSeller.data._id,
      //     };
      //     arrPartner.push(contactpartnerSeller);
      //   }
      // });
      // if (contactPartner === "buyer_partner") {
      //   const newPartnerSeller = {
      //     type: contactPartner,
      //     contactId: select._id,
      //   };
      //   arrPartner.push(newPartnerSeller);
      // }
  
      transactionId.contact10.forEach((itemData) => {
        if (itemData) {
          arrHome.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactHome === "home_Warrenty") {
        arrHome.push({
          type: contactHome,
          contactId: select._id,
        });
      }
  
      // transactionId.contact10.map((homeSeller) => {
      //   if (homeSeller) {
      //     const contacthomerSeller = {
      //       type: homeSeller.data.type,
      //       contactId: homeSeller.data._id,
      //     };
      //     arrHome.push(contacthomerSeller);
      //   }
      // });
      // if (contactHome === "home_Warrenty") {
      //   const newHomeSeller = {
      //     type: contactHome,
      //     contactId: select._id,
      //   };
      //   arrHome.push(newHomeSeller);
      // }
  
      transactionId.contact11.forEach((itemData) => {
        if (itemData) {
          arrLender.push({
            type: itemData.data.type,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactLender === "buyer_lender") {
        arrLender.push({
          type: contactLender,
          contactId: select._id,
        });
      }
  
      // transactionId.contact11.map((lenderSeller) => {
      //   if (lenderSeller) {
      //     const contactLenderSeller = {
      //       type: lenderSeller.data.type,
      //       contactId: lenderSeller.data._id,
      //     };
      //     arrLender.push(contactLenderSeller);
      //   }
      // });
      // if (contactLender === "buyer_lender") {
      //   const newLenderSeller = {
      //     type: contactLender,
      //     contactId: select._id,
      //   };
      //   arrLender.push(newLenderSeller);
      // }
  
      transactionId.contact12.forEach((itemData) => {
        if (itemData) {
          arrOther.push({
            type: itemData.data.type,
            name_other: itemData.data.name_other,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactSellerOther === "seller_other") {
        arrOther.push({
          type: contactSellerOther,
          name_other: otherSideValue,
          contactId: select._id,
        });
      }
  
      // transactionId.contact12.map((otherSeller) => {
      //   if (otherSeller) {
      //     const contactSellerOther = {
      //       type: otherSeller.data.type,
      //       name_other: otherSeller.data.name_other,
      //       contactId: otherSeller.data._id,
      //     };
      //     arrOther.push(contactSellerOther);
      //   }
      // });
      // if (contactSellerOther === "seller_other") {
      //   const newSellerOther = {
      //     type: contactSellerOther,
      //     name_other: otherSideValue,
      //     contactId: select._id,
      //   };
      //   arrOther.push(newSellerOther);
      // }
  
      transactionId.contact13.forEach((itemData) => {
        if (itemData) {
          arrBuyerOther.push({
            type: itemData.data.type,
            name_other: itemData.data.name_other,
            contactId: itemData.data._id,
          });
        }
      });
  
      if (contactBuyerOther === "other_buyer") {
        arrBuyerOther.push({
          type: contactBuyerOther,
          name_other: otherSideBuyer,
          contactId: select._id,
        });
      }
  
  
      // transactionId.contact13.map((otherBuyer) => {
      //   if (otherBuyer) {
      //     const contactBuyerOther = {
      //       type: otherBuyer.data.type,
      //       name_other: otherBuyer.data.name_other,
      //       contactId: otherBuyer.data._id,
      //     };
      //     arrBuyerOther.push(contactBuyerOther);
      //   }
      // });
      // if (contactBuyerOther === "other_buyer") {
      //   const newBuyerOther = {
      //     type: contactBuyerOther,
      //     name_other: otherSideBuyer,
      //     contactId: select._id,
      //   };
      //   arrBuyerOther.push(newBuyerOther);
      // }
      
    }
  
   else if (transactionId.represent === "both") {
      transactionId.contact1.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          arr.push(contactbuyer);
        }
      });
  
      if (represent === "sellersale") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }
  
      transactionId.contact2.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          array.push(contact);
        }
      });
  
      if (type === "buyersale") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }
  
      transactionId.contact3.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrsellerAgent.push(contactbuyerAgent);
        }
      });
  
      if (phase === "sale_Agent") {
        const newUserbuyer = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserbuyer);
      }
  
      transactionId.contact4.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrbuyerAgent.push(contactsellerAgent);
        }
      });
      if (represent === "buy_Agent") {
        const newUserseller = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserseller);
      }
      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }
  
      transactionId.contact6.map((vendor) => {
        if (vendor) {
          const contactVendor = {
            type: vendor.data.type,
            contactId: vendor.data._id,
          };
          arrVendor.push(contactVendor);
        }
      });
      if (contactValue === "Vendor") {
        const newuser = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newuser);
      }
  
  
      transactionId.contact12.map((otherSeller) => {
        if (otherSeller) {
          const contactSellerOther = {
            type: otherSeller.data.type,
            name_other: otherSeller.data.name_other,
            contactId: otherSeller.data._id,
          };
          arrOther.push(contactSellerOther);
        }
      });
      if (contactSellerOther === "seller_other") {
        const newSellerOther = {
          type: contactSellerOther,
          name_other: otherSideValue,
          contactId: select._id,
        };
        arrOther.push(newSellerOther);
      }
  
  
      transactionId.contact13.map((otherBuyer) => {
        if (otherBuyer) {
          const contactBuyerOther = {
            type: otherBuyer.data.type,
            name_other: otherBuyer.data.name_other,
            contactId: otherBuyer.data._id,
          };
          arrBuyerOther.push(contactBuyerOther);
        }
      });
      if (contactBuyerOther === "other_buyer") {
        const newBuyerOther = {
          type: contactBuyerOther,
          name_other: otherSideBuyer,
          contactId: select._id,
        };
        arrBuyerOther.push(newBuyerOther);
      }     
    } 
    else if (transactionId.represent === "referral") {
      transactionId.contact1.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          arr.push(contactbuyer);
        }
      });
  
      if (represent === "referralsale") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }
  
      transactionId.contact2.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          array.push(contact);
        }
      });
      if (type === "referral_sellerAgent") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }
  
      transactionId.contact3.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrsellerAgent.push(contactbuyerAgent);
        }
      });
  
      if (phase === "referral_Agent") {
        const newUserbuyer = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserbuyer);
      }
  
      transactionId.contact4.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrbuyerAgent.push(contactsellerAgent);
        }
      });
  
      if (represent === "referralbuy_Agent") {
        const newUserseller = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserseller);
      }
      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }
      transactionId.contact6.map((vendor) => {
        if (vendor) {
          const contactVendor = {
            type: vendor.data.type,
            contactId: vendor.data._id,
          };
          arrVendor.push(contactVendor);
        }
      });
      if (contactValue === "Vendor") {
        const newuser = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newuser);
      }
  
      transactionId.contact12.map((otherSeller) => {
        if (otherSeller) {
          const contactSellerOther = {
            type: otherSeller.data.type,
            name_other: otherSeller.data.name_other,
            contactId: otherSeller.data._id,
          };
          arrOther.push(contactSellerOther);
        }
      });
      if (contactSellerOther === "seller_other") {
        const newSellerOther = {
          type: contactSellerOther,
          name_other: otherSideValue,
          contactId: select._id,
        };
        arrOther.push(newSellerOther);
      }
  
  
      transactionId.contact13.map((otherBuyer) => {
        if (otherBuyer) {
          const contactBuyerOther = {
            type: otherBuyer.data.type,
            name_other: otherBuyer.data.name_other,
            contactId: otherBuyer.data._id,
          };
          arrBuyerOther.push(contactBuyerOther);
        }
      });
      if (contactBuyerOther === "other_buyer") {
        const newBuyerOther = {
          type: contactBuyerOther,
          name_other: otherSideBuyer,
          contactId: select._id,
        };
        arrBuyerOther.push(newBuyerOther);
      }
    }
  
    try {
      const userData = {
        contact1: arr,
        contact2: array,
        contact3: arrsellerAgent,
        contact4: arrbuyerAgent,
        contact5: arrCoordinator,
        contact6: arrVendor,
        contact7: arrAttorney,
        contact8: arrVendorNew,
        contact9: arrPartner,
        contact10: arrHome,
        contact11: arrLender,
        contact12: arrOther,
        contact13: arrBuyerOther,
      };
      setLoader({ isActive: true });
      await user_service
        .TransactionUpdate(params.id, userData)
        .then((response) => {
          if (response.status === 200) {
            const userDatan = {
              addedBy: jwt(localStorage.getItem("auth")).id,
              agentId: jwt(localStorage.getItem("auth")).id,
              transactionId: params.id,
              message: `Contact ${contactTitle} added.`,
              note_type: "Contact",
            };
            
            const responsen = user_service.transactionNotes(userDatan);
            
  
            setTransactionId(response.data);
            setAddContact(response.data._id);
            setSelect("");
            setRepresent("");
            setType("");
            setPhase("");
            setRepresent("");
            setContact("");
            setContactValue("");
            setContactNew("");
            setContactVendor("");
            setContactPartner("");
            setContactHome("");
            setContactLender("");
            setContactSellerOther("");
            setContactBuyerOther("");
            setContactTitle("");
            setSelectedSide("");
            setLoader({ isActive: false });
            setToaster({
              types: "Transaction Updated",
              isShow: true,
              toasterBody: response.data.message,
              message: "Transaction Contact Updated Successfully",
            });
  
            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 3000);
  
            const TransactionGetById = async () => {
              await user_service
                .transactionGetById(params.id)
                .then((response) => {
                  if (response) {
                    setTransactionId(response.data);
                  }
                });
            };
            TransactionGetById(params.id);
  
            document.getElementById("closeModalp").click(); 
            document.getElementById("closeModalnew").click(); 
            document.getElementById("closeModal").click(); 
          } 
        });
    } catch (error) {
      setLoader({ isActive: false });
      setToaster({
        types: "error",
        isShow: true,
        message: "Error",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 2000);
    }
  };
  

  const selectContactss = async () => {
    let arr = [];
    let array = [];
    let arrsellerAgent = [];
    let arrbuyerAgent = [];
    let arrCoordinator = [];
    let arrVendor = [];
    let arrAttorney = [];
    let arrVendorNew = [];
    let arrPartner = [];
    let arrHome = [];
    let arrLender = [];
    let arrOther= [];
    let arrBuyerOther= [];

    if (transactionId.represent === "seller") {
      transactionId.contact1.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          arr.push(contact);
        }
      });
      if (represent === "seller") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }

      transactionId.contact2.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          array.push(contactbuyer);
        }
      });
      if (type === "buyer") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }

      transactionId.contact3.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrsellerAgent.push(contactsellerAgent);
        }
      });
      if (phase === "seller_Agent") {
        const newUserseller = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserseller);
      }

      transactionId.contact4.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrbuyerAgent.push(contactbuyerAgent);
        }
      });

      if (represent === "buyer_Agent") {
        const newUserbuyer = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserbuyer);
      }

      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }

      transactionId.contact6.map((vendorSeller) => {
        if (vendorSeller) {
          const contactSeller = {
            type: vendorSeller.data.type,
            contactId: vendorSeller.data._id,
          };
          arrVendor.push(contactSeller);
        }
      });
      if (contactValue === "seller_Title") {
        const newSellerTitle = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newSellerTitle);
      }

      transactionId.contact7.map((attorneySeller) => {
        if (attorneySeller) {
          const contactAttorneySeller = {
            type: attorneySeller.data.type,
            contactId: attorneySeller.data._id,
          };
          arrAttorney.push(contactAttorneySeller);
        }
      });
      if (contactNew === "seller_Attorney") {
        const newAttorneySeller = {
          type: contactNew,
          contactId: select._id,
        };
        arrAttorney.push(newAttorneySeller);
      }

      transactionId.contact8.map((VendorSeller) => {
        if (VendorSeller) {
          const contactVendorSeller = {
            type: VendorSeller.data.type,
            contactId: VendorSeller.data._id,
          };
          arrVendorNew.push(contactVendorSeller);
        }
      });
      if (contactVendor === "vendorNew") {
        const newVendorSeller = {
          type: contactVendor,
          contactId: select._id,
        };
        arrVendorNew.push(newVendorSeller);
      }

      transactionId.contact9.map((partnerSeller) => {
        if (partnerSeller) {
          const contactpartnerSeller = {
            type: partnerSeller.data.type,
            contactId: partnerSeller.data._id,
          };
          arrPartner.push(contactpartnerSeller);
        }
      });
      if (contactPartner === "seller_partner") {
        const newPartnerSeller = {
          type: contactPartner,
          contactId: select._id,
        };
        arrPartner.push(newPartnerSeller);
      }

      transactionId.contact10.map((homeSeller) => {
        if (homeSeller) {
          const contacthomerSeller = {
            type: homeSeller.data.type,
            contactId: homeSeller.data._id,
          };
          arrHome.push(contacthomerSeller);
        }
      });
      if (contactHome === "home_Warrenty") {
        const newHomeSeller = {
          type: contactHome,
          contactId: select._id,
        };
        arrHome.push(newHomeSeller);
      }
      

      transactionId.contact11.map((lenderSeller) => {
        if (lenderSeller) {
          const contactLenderSeller = {
            type: lenderSeller.data.type,
            contactId: lenderSeller.data._id,
          };
          arrLender.push(contactLenderSeller);
        }
      });
      if (contactLender === "buyer_lender") {
        const newLenderSeller = {
          type: contactLender,
          contactId: select._id,
        };
        arrLender.push(newLenderSeller);
      }
    

    transactionId.contact12.map((otherSeller) => {
      if (otherSeller) {
        const contactSellerOther = {
          type: otherSeller.data.type,
          name_other: otherSeller.data.name_other,
          contactId: otherSeller.data._id,
        };
        arrOther.push(contactSellerOther);
      }
    });
    if (contactSellerOther === "seller_other") {
      const newSellerOther = {
        type: contactSellerOther,
        name_other: otherSideValue,
        contactId: select._id,
      };
      arrOther.push(newSellerOther);
    }


    transactionId.contact13.map((otherBuyer) => {
      if (otherBuyer) {
        const contactBuyerOther = {
          type: otherBuyer.data.type,
          name_other: otherBuyer.data.name_other,
          contactId: otherBuyer.data._id,
        };
        arrBuyerOther.push(contactBuyerOther);
      }
    });
    if (contactBuyerOther === "other_buyer") {
      const newBuyerOther = {
        type: contactBuyerOther,
        name_other: otherSideBuyer,
        contactId: select._id,
      };
      arrBuyerOther.push(newBuyerOther);
    }
    
  }
    
  else if (transactionId.represent === "buyer") {

    transactionId.contact1.forEach((post) => {
      if (post) {
        arr.push({
          type: post.data.type,
          contactId: post.data._id,
        });
      }
    });

    if (represent === "buyer") {
      arr.push({
        type: represent,
        contactId: select._id,
      });
    }

    // transactionId.contact1.map((post) => {
    //   if (post) {
    //     const contactbuyer = {
    //       type: post.data.type,
    //       contactId: post.data._id,
    //     };
    //     arr.push(contactbuyer);
    //   }
    // });

    // if (represent === "buyer") {
    //   const newuser = {
    //     type: represent,
    //     contactId: select._id,
    //   };
    //   arr.push(newuser);
    // }

    // transactionId.contact2.map((item) => {
    //   if (item) {
    //     const contact = {
    //       type: item.data.type,
    //       contactId: item.data._id,
    //     };
    //     array.push(contact);
    //   }
    // });

    // if (type === "seller") {
    //   const newuser = {
    //     type: type,
    //     contactId: select._id,
    //   };
    //   array.push(newuser);
    // }

    // transactionId.contact3.map((itemData) => {
    //   if (itemData) {
    //     const contactbuyerAgent = {
    //       type: itemData.data.type,
    //       contactId: itemData.data._id,
    //     };
    //     arrsellerAgent.push(contactbuyerAgent);
    //   }
    // });

    // if (phase === "buyer_Agent") {
    //   const newUserbuyer = {
    //     type: phase,
    //     contactId: select._id,
    //   };
    //   arrsellerAgent.push(newUserbuyer);
    // }

    transactionId.contact2.forEach((item) => {
      if (item) {
        array.push({
          type: item.data.type,
          contactId: item.data._id,
        });
      }
    });

    if (type === "seller") {
      array.push({
        type: type,
        contactId: select._id,
      });
    }

    // Process contact3
    transactionId.contact3.forEach((itemData) => {
      if (itemData) {
        arrsellerAgent.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (phase === "buyer_Agent") {
      arrsellerAgent.push({
        type: phase,
        contactId: select._id,
      });
    }

    transactionId.contact4.forEach((itemData) => {
      if (itemData) {
        arrbuyerAgent.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (represent === "seller_Agent") {
      arrbuyerAgent.push({
        type: represent,
        contactId: select._id,
      });
    }


    // transactionId.contact4.map((postData) => {
    //   if (postData) {
    //     const contactsellerAgent = {
    //       type: postData.data.type,
    //       contactId: postData.data._id,
    //     };
    //     arrbuyerAgent.push(contactsellerAgent);
    //   }
    // });
    // if (represent === "seller_Agent") {
    //   const newUserseller = {
    //     type: represent,
    //     contactId: select._id,
    //   };
    //   arrbuyerAgent.push(newUserseller);
    // }


    transactionId.contact5.forEach((itemData) => {
      if (itemData) {
        arrCoordinator.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contact === "Coordinator") {
      arrCoordinator.push({
        type: contact,
        contactId: select._id,
      });
    }

    // transactionId.contact5.map((coordinator) => {
    //   if (coordinator) {
    //     const contactCoordinator = {
    //       type: coordinator.data.type,
    //       contactId: coordinator.data._id,
    //     };
    //     arrCoordinator.push(contactCoordinator);
    //   }
    // });
    // if (contact === "Coordinator") {
    //   const newuserCoordinator = {
    //     type: contact,
    //     contactId: select._id,
    //   };
    //   arrCoordinator.push(newuserCoordinator);
    // }

    transactionId.contact6.forEach((itemData) => {
      if (itemData) {
        arrVendor.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactValue === "buyer_Title") {
      arrVendor.push({
        type: contactValue,
        contactId: select._id,
      });
    }

    // transactionId.contact6.map((vendorBuyer) => {
    //   if (vendorBuyer) {
    //     const contactBuyer = {
    //       type: vendorBuyer.data.type,
    //       contactId: vendorBuyer.data._id,
    //     };
    //     arrVendor.push(contactBuyer);
    //   }
    // });
    // if (contactValue === "buyer_Title") {
    //   const newuserBuyer = {
    //     type: contactValue,
    //     contactId: select._id,
    //   };
    //   arrVendor.push(newuserBuyer);
    // }


    transactionId.contact7.forEach((itemData) => {
      if (itemData) {
        arrAttorney.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactNew === "buyer_Attorney") {
      arrAttorney.push({
        type: contactNew,
        contactId: select._id,
      });
    }
   



    // transactionId.contact7.map((attorneyBuyer) => {
    //   if (attorneyBuyer) {
    //     const contactAttorneyBuyer = {
    //       type: attorneyBuyer.data.type,
    //       contactId: attorneyBuyer.data._id,
    //     };
    //     arrAttorney.push(contactAttorneyBuyer);
    //   }
    // });
    // if (contactNew === "buyer_Attorney") {
    //   const newAttorneyBuyer = {
    //     type: contactNew,
    //     contactId: select._id,
    //   };
    //   arrAttorney.push(newAttorneyBuyer);
    // }

    transactionId.contact8.forEach((itemData) => {
      if (itemData) {
        arrVendorNew.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactVendor === "vendorNew") {
      arrVendorNew.push({
        type: contactVendor,
        contactId: select._id,
      });
    }

    // transactionId.contact8.map((VendorSeller) => {
    //   if (VendorSeller) {
    //     const contactVendorSeller = {
    //       type: VendorSeller.data.type,
    //       contactId: VendorSeller.data._id,
    //     };
    //     arrVendorNew.push(contactVendorSeller);
    //   }
    // });
    // if (contactVendor === "vendorNew") {
    //   const newVendorSeller = {
    //     type: contactVendor,
    //     contactId: select._id,
    //   };
    //   arrVendorNew.push(newVendorSeller);
    // }

    transactionId.contact9.forEach((itemData) => {
      if (itemData) {
        arrPartner.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactPartner === "buyer_partner") {
      arrPartner.push({
        type: contactPartner,
        contactId: select._id,
      });
    }

    // transactionId.contact9.map((partnerSeller) => {
    //   if (partnerSeller) {
    //     const contactpartnerSeller = {
    //       type: partnerSeller.data.type,
    //       contactId: partnerSeller.data._id,
    //     };
    //     arrPartner.push(contactpartnerSeller);
    //   }
    // });
    // if (contactPartner === "buyer_partner") {
    //   const newPartnerSeller = {
    //     type: contactPartner,
    //     contactId: select._id,
    //   };
    //   arrPartner.push(newPartnerSeller);
    // }

    transactionId.contact10.forEach((itemData) => {
      if (itemData) {
        arrHome.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactHome === "home_Warrenty") {
      arrHome.push({
        type: contactHome,
        contactId: select._id,
      });
    }

    // transactionId.contact10.map((homeSeller) => {
    //   if (homeSeller) {
    //     const contacthomerSeller = {
    //       type: homeSeller.data.type,
    //       contactId: homeSeller.data._id,
    //     };
    //     arrHome.push(contacthomerSeller);
    //   }
    // });
    // if (contactHome === "home_Warrenty") {
    //   const newHomeSeller = {
    //     type: contactHome,
    //     contactId: select._id,
    //   };
    //   arrHome.push(newHomeSeller);
    // }

    transactionId.contact11.forEach((itemData) => {
      if (itemData) {
        arrLender.push({
          type: itemData.data.type,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactLender === "buyer_lender") {
      arrLender.push({
        type: contactLender,
        contactId: select._id,
      });
    }

    // transactionId.contact11.map((lenderSeller) => {
    //   if (lenderSeller) {
    //     const contactLenderSeller = {
    //       type: lenderSeller.data.type,
    //       contactId: lenderSeller.data._id,
    //     };
    //     arrLender.push(contactLenderSeller);
    //   }
    // });
    // if (contactLender === "buyer_lender") {
    //   const newLenderSeller = {
    //     type: contactLender,
    //     contactId: select._id,
    //   };
    //   arrLender.push(newLenderSeller);
    // }

    transactionId.contact12.forEach((itemData) => {
      if (itemData) {
        arrOther.push({
          type: itemData.data.type,
          name_other: itemData.data.name_other,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactSellerOther === "seller_other") {
      arrOther.push({
        type: contactSellerOther,
        name_other: otherSideValue,
        contactId: select._id,
      });
    }

    // transactionId.contact12.map((otherSeller) => {
    //   if (otherSeller) {
    //     const contactSellerOther = {
    //       type: otherSeller.data.type,
    //       name_other: otherSeller.data.name_other,
    //       contactId: otherSeller.data._id,
    //     };
    //     arrOther.push(contactSellerOther);
    //   }
    // });
    // if (contactSellerOther === "seller_other") {
    //   const newSellerOther = {
    //     type: contactSellerOther,
    //     name_other: otherSideValue,
    //     contactId: select._id,
    //   };
    //   arrOther.push(newSellerOther);
    // }

    transactionId.contact13.forEach((itemData) => {
      if (itemData) {
        arrBuyerOther.push({
          type: itemData.data.type,
          name_other: itemData.data.name_other,
          contactId: itemData.data._id,
        });
      }
    });

    if (contactBuyerOther === "other_buyer") {
      arrBuyerOther.push({
        type: contactBuyerOther,
        name_other: otherSideBuyer,
        contactId: select._id,
      });
    }


    // transactionId.contact13.map((otherBuyer) => {
    //   if (otherBuyer) {
    //     const contactBuyerOther = {
    //       type: otherBuyer.data.type,
    //       name_other: otherBuyer.data.name_other,
    //       contactId: otherBuyer.data._id,
    //     };
    //     arrBuyerOther.push(contactBuyerOther);
    //   }
    // });
    // if (contactBuyerOther === "other_buyer") {
    //   const newBuyerOther = {
    //     type: contactBuyerOther,
    //     name_other: otherSideBuyer,
    //     contactId: select._id,
    //   };
    //   arrBuyerOther.push(newBuyerOther);
    // }
    
  }
    
    else if (transactionId.represent === "both") {
      transactionId.contact1.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          arr.push(contactbuyer);
        }
      });

      if (represent === "sellersale") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }

      transactionId.contact2.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          array.push(contact);
        }
      });

      if (type === "buyersale") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }

      transactionId.contact3.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrsellerAgent.push(contactbuyerAgent);
        }
      });
      if (phase === "sale_Agent") {
        const newUserbuyer = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserbuyer);
      }

      transactionId.contact4.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrbuyerAgent.push(contactsellerAgent);
        }
      });
      if (represent === "buy_Agent") {
        const newUserseller = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserseller);
      }
      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }
      transactionId.contact6.map((vendor) => {
        if (vendor) {
          const contactVendor = {
            type: vendor.data.type,
            contactId: vendor.data._id,
          };
          arrVendor.push(contactVendor);
        }
      });
      if (contactValue === "Vendor") {
        const newuser = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newuser);
      }

      transactionId.contact12.map((otherSeller) => {
        if (otherSeller) {
          const contactSellerOther = {
            type: otherSeller.data.type,
            name_other: otherSeller.data.name_other,
            contactId: otherSeller.data._id,
          };
          arrOther.push(contactSellerOther);
        }
      });
      if (contactSellerOther === "seller_other") {
        const newSellerOther = {
          type: contactSellerOther,
          name_other: otherSideValue,
          contactId: select._id,
        };
        arrOther.push(newSellerOther);
      }
  
  
      transactionId.contact13.map((otherBuyer) => {
        if (otherBuyer) {
          const contactBuyerOther = {
            type: otherBuyer.data.type,
            name_other: otherBuyer.data.name_other,
            contactId: otherBuyer.data._id,
          };
          arrBuyerOther.push(contactBuyerOther);
        }
      });
      if (contactBuyerOther === "other_buyer") {
        const newBuyerOther = {
          type: contactBuyerOther,
          name_other: otherSideBuyer,
          contactId: select._id,
        };
        arrBuyerOther.push(newBuyerOther);
      }
      
    } 
    
    else if (transactionId.represent === "referral") {
      transactionId.contact1.map((post) => {
        if (post) {
          const contactbuyer = {
            type: post.data.type,
            contactId: post.data._id,
          };
          arr.push(contactbuyer);
        }
      });

      if (represent === "referralsale") {
        const newuser = {
          type: represent,
          contactId: select._id,
        };
        arr.push(newuser);
      }

      transactionId.contact2.map((item) => {
        if (item) {
          const contact = {
            type: item.data.type,
            contactId: item.data._id,
          };
          array.push(contact);
        }
      });

      if (type === "referral_sellerAgent") {
        const newuser = {
          type: type,
          contactId: select._id,
        };
        array.push(newuser);
      }

      transactionId.contact3.map((itemData) => {
        if (itemData) {
          const contactbuyerAgent = {
            type: itemData.data.type,
            contactId: itemData.data._id,
          };
          arrsellerAgent.push(contactbuyerAgent);
        }
      });
      if (phase === "referral_Agent") {
        const newUserbuyer = {
          type: phase,
          contactId: select._id,
        };
        arrsellerAgent.push(newUserbuyer);
      }

      transactionId.contact4.map((postData) => {
        if (postData) {
          const contactsellerAgent = {
            type: postData.data.type,
            contactId: postData.data._id,
          };
          arrbuyerAgent.push(contactsellerAgent);
        }
      });
      if (represent === "referralbuy_Agent") {
        const newUserseller = {
          type: represent,
          contactId: select._id,
        };
        arrbuyerAgent.push(newUserseller);
      }
      transactionId.contact5.map((coordinator) => {
        if (coordinator) {
          const contactCoordinator = {
            type: coordinator.data.type,
            contactId: coordinator.data._id,
          };
          arrCoordinator.push(contactCoordinator);
        }
      });
      if (contact === "Coordinator") {
        const newuserCoordinator = {
          type: contact,
          contactId: select._id,
        };
        arrCoordinator.push(newuserCoordinator);
      }
      transactionId.contact6.map((vendor) => {
        if (vendor) {
          const contactVendor = {
            type: vendor.data.type,
            contactId: vendor.data._id,
          };
          arrVendor.push(contactVendor);
        }
      });
      if (contactValue === "Vendor") {
        const newuser = {
          type: contactValue,
          contactId: select._id,
        };
        arrVendor.push(newuser);
      }

      transactionId.contact12.map((otherSeller) => {
        if (otherSeller) {
          const contactSellerOther = {
            type: otherSeller.data.type,
            name_other: otherSeller.data.name_other,
            contactId: otherSeller.data._id,
          };
          arrOther.push(contactSellerOther);
        }
      });
      if (contactSellerOther === "seller_other") {
        const newSellerOther = {
          type: contactSellerOther,
          name_other: otherSideValue,
          contactId: select._id,
        };
        arrOther.push(newSellerOther);
      }
  
  
      transactionId.contact13.map((otherBuyer) => {
        if (otherBuyer) {
          const contactBuyerOther = {
            type: otherBuyer.data.type,
            name_other: otherBuyer.data.name_other,
            contactId: otherBuyer.data._id,
          };
          arrBuyerOther.push(contactBuyerOther);
        }
      });
      if (contactBuyerOther === "other_buyer") {
        const newBuyerOther = {
          type: contactBuyerOther,
          name_other: otherSideBuyer,
          contactId: select._id,
        };
        arrBuyerOther.push(newBuyerOther);
      }
      
    }

    try {
      const userData = {
        contact1: arr,
        contact2: array,
        contact3: arrsellerAgent,
        contact4: arrbuyerAgent,
        contact5: arrCoordinator,
        contact6: arrVendor,
        contact7: arrAttorney,
        contact8: arrVendorNew,
        contact9: arrPartner,
        contact10: arrHome,
        contact11: arrLender,
        contact12: arrOther,
        contact13: arrBuyerOther,
      };
      setLoader({ isActive: true });
      await user_service
        .TransactionUpdate(params.id, userData)
        .then((response) => {
          if (response.status === 200) {
            const userDatan = {
              addedBy: jwt(localStorage.getItem("auth")).id,
              agentId: jwt(localStorage.getItem("auth")).id,
              transactionId: params.id,
              message: `Contact ${contactTitle} added.`,
              // transaction_property_address: "ADDRESS 2",
              note_type: "Contact",
            };
            const responsen = user_service.transactionNotes(userDatan);

            setTransactionId(response.data);
            setAddContact(response.data._id);
            setSelect("");
            setRepresent("");
            setType("");
            setPhase("");
            setRepresent("");
            setContact("");
            setContactNew("");
            setContactVendor("");
            setContactPartner("");
            setContactHome("");
            setContactLender("");
            setContactSellerOther("");
            setContactBuyerOther("");
            setContactTitle("");
            setSelectedSide("");
            setContactValue("");
            setLoader({ isActive: false });
            setToaster({
              types: "Transaction Updated",
              isShow: true,
              toasterBody: response.data.message,
              message: "Transaction Contact Updated Successfully",
            });

            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 3000);

            const TransactionGetById = async () => {
              await user_service
                .transactionGetById(params.id)
                .then((response) => {
                  if (response) {
                    setTransactionId(response.data);
                  }
                });
            };
            TransactionGetById(params.id);
            document.getElementById("closeModalp").click();
            document.getElementById("closeModal").click();
            document.getElementById("closeModalnew").click();
          } 
        });
    } catch (error) {
      setLoader({ isActive: false });
      setToaster({
        types: "error",
        isShow: true,
        message: "Error",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 2000);
    }
  };

  const handleDelete = async (id, arrDelete, contactData) => {
 
    let transactionArray = [];
    if (transactionId) {
      if (transactionId.contact1) {
        let arr = transactionId.contact1;
      
        if (contactData === "contact1") {
          if (transactionId.contact1.length > 1) {
            const objWithIdIndex = arr.findIndex((obj) => obj.data._id === id);
            if (objWithIdIndex > -1) {
              arr.splice(objWithIdIndex, 1);
              setShowPopup(true);
              setShowModal(false);
            }
          } else {
            setShowModal(true);
            setShowPopup(false);

            return;
          }
        }
        arr.map((item) => {
          if (item) {
            const contact = {
              type: item.data.type,
              contactId: item.data._id,
            };
            transactionArray.push(contact);
          }
        });
      }
    }

    let arraybuyer = [];

    let buyerArray = transactionId.contact2;
    if (contactData === "contact2") {
      const buyerIndex = buyerArray.findIndex((obj) => obj.data._id === id);
      if (buyerIndex > -1) {
        buyerArray.splice(buyerIndex, 1);
      }
    }

    buyerArray.map((item) => {
      if (item) {
        const contactArrbuyer = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arraybuyer.push(contactArrbuyer);
      }
    });
    let arrsellerAgent = [];

    let sellerAgentAarray = transactionId.contact3;
    if (contactData === "contact3") {
      const sellerAgentIndex = sellerAgentAarray.findIndex(
        (obj) => obj.data._id === id
      );
      if (sellerAgentIndex > -1) {
        sellerAgentAarray.splice(sellerAgentIndex, 1);
      }
    }
    sellerAgentAarray.map((item) => {
      if (item) {
        const contactarrseller = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrsellerAgent.push(contactarrseller);
      }
    });

    let arrbuyerAgent = [];
    let buyerAgentAarray = transactionId.contact4;
    if (contactData === "contact4") {
      const buyerAgentIndex = buyerAgentAarray.findIndex(
        (obj) => obj.data._id === id
      );
      if (buyerAgentIndex > -1) {
        buyerAgentAarray.splice(buyerAgentIndex, 1);
      }
    }

    buyerAgentAarray.map((item) => {
      if (item) {
        const contactarrbuyerAgent = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrbuyerAgent.push(contactarrbuyerAgent);
      }
    });

    let arrCoordinator = [];
    let coordinatorAarray = transactionId.contact5;
    if (contactData === "contact5") {
      const coordinatorIndex = coordinatorAarray.findIndex(
        (obj) => obj.data._id === id
      );
      if (coordinatorIndex > -1) {
        coordinatorAarray.splice(coordinatorIndex, 1);
      }
    }

    coordinatorAarray.map((item) => {
      if (item) {
        const contactarrsellerAgent = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrCoordinator.push(contactarrsellerAgent);
      }
    });

    let arrVendor = [];

    let vendorArray = transactionId.contact6;
    if (contactData === "contact6") {
      const venderIndex = vendorArray.findIndex((obj) => obj.data._id === id);
      if (venderIndex > -1) {
        vendorArray.splice(venderIndex, 1);
      }
    }

    vendorArray.map((item) => {
      if (item) {
        const contactVander = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrVendor.push(contactVander);
      }
    });

    let arrAttorney = [];

    let attorneyArray = transactionId.contact7;
    if (contactData === "contact7") {
      const attoneyIndex = attorneyArray.findIndex(
        (obj) => obj.data._id === id
      );
      if (attoneyIndex > -1) {
        attorneyArray.splice(attoneyIndex, 1);
      }
    }

    attorneyArray.map((item) => {
      if (item) {
        const contactAttorney = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrAttorney.push(contactAttorney);
      }
    });

    let arrVendorNew = [];

    let vendorNewArray = transactionId.contact8;
    if (contactData === "contact8") {
      const VendorIndex = vendorNewArray.findIndex(
        (obj) => obj.data._id === id
      );
      if (VendorIndex > -1) {
        vendorNewArray.splice(VendorIndex, 1);
      }
    }

    vendorNewArray.map((item) => {
      if (item) {
        const contactNewVendor = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrVendorNew.push(contactNewVendor);
      }
    });

    let arrPartner = [];

    let partnerArray = transactionId.contact9;
    if (contactData === "contact9") {
      const partnerIndex = partnerArray.findIndex((obj) => obj.data._id === id);
      if (partnerIndex > -1) {
        partnerArray.splice(partnerIndex, 1);
      }
    }

    partnerArray.map((item) => {
      if (item) {
        const contactNewpartner = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrPartner.push(contactNewpartner);
      }
    });

    let arrHome = [];

    let homeArray = transactionId.contact10;
    if (contactData === "contact10") {
      const homeIndex = homeArray.findIndex((obj) => obj.data._id === id);
      if (homeIndex > -1) {
        homeArray.splice(homeIndex, 1);
      }
    }

    homeArray.map((item) => {
      if (item) {
        const contactNewpHome = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrHome.push(contactNewpHome);
      }
    });

    let arrLender = [];

    let lenderArray = transactionId.contact11;
    if (contactData === "contact11") {
      const lenderIndex = lenderArray.findIndex((obj) => obj.data._id === id);
      if (lenderIndex > -1) {
        lenderArray.splice(lenderIndex, 1);
      }
    }

    lenderArray.map((item) => {
      if (item) {
        const contactNewLender = {
          type: item.data.type,
          contactId: item.data._id,
        };
        arrLender.push(contactNewLender);
      }
    });
    

    let arrSellerOther = [];

    let otherSellerArray = transactionId.contact12;
    if (contactData === "contact12") {
      const sellerOtherIndex = otherSellerArray.findIndex((obj) => obj.data._id === id);
      if (sellerOtherIndex > -1) {
        otherSellerArray.splice(sellerOtherIndex, 1);
      }
    }

    otherSellerArray.map((item) => {
      if (item) {
        const sellerOther = {
          type: item.data.type,
          name_other: item.data.name_other,
          contactId: item.data._id,
        };
        arrSellerOther.push(sellerOther);
      }
    });

    let arrBuyerOther = [];

    let otherBuyerArray = transactionId.contact13;
    if (contactData === "contact13") {
      const buyerOtherIndex = otherBuyerArray.findIndex((obj) => obj.data._id === id);
      if (buyerOtherIndex > -1) {
        otherBuyerArray.splice(buyerOtherIndex, 1);
      }
    }

    otherBuyerArray.map((item) => {
      if (item) {
        const buyerOther = {
          type: item.data.type,
          name_other: item.data.name_other,
          contactId: item.data._id,
        };
        arrBuyerOther.push(buyerOther);
      }
    });

    try {
      const userData = {
        contact1: transactionArray,
        contact2: arraybuyer,
        contact3: arrsellerAgent,
        contact4: arrbuyerAgent,
        contact5: arrCoordinator,
        contact6: arrVendor,
        contact7: arrAttorney,
        contact8: arrVendorNew,
        contact9: arrPartner,
        contact10: arrHome,
        contact11: arrLender,
        contact12: arrSellerOther,
        contact13: arrBuyerOther,

        // propertyDetail: params.pid,
        // category: transactionId.category,
      };
      setLoader({ isActive: true });
      await user_service
        .TransactionUpdate(params.id, userData)
        .then((response) => {
          if (response.status === 200) {
            const splitValues = arrDelete.split("_"); 
            const userDatan = {
              addedBy: jwt(localStorage.getItem("auth")).id,
              agentId: jwt(localStorage.getItem("auth")).id,
              transactionId: params.id,
              message: `Contact ${splitValues.join("  ")} removed.`,
              // transaction_property_address: "ADDRESS 2",
              note_type: "Contact Delete",
            };
            const responsen = user_service.transactionNotes(userDatan);
            setTransactionId(response.data);
            setShowPopup(false);
            setPopup(false);
            setPopupPhase(false);
            setPopupContact(false);
            setPopupContactAttoney(false);
            setPopupContactVendor(false);
            setPopupContactPartner(false);
            setPopupContactHome(false);
            setPopupLender(false);
            setPopupRepresent(false);
            setPopupValue(false);
            setPopupSellerOther(false);
            setPopupBuyerOther(false)
            setRepresent("");
            setType("");
            setPhase("");
            setRepresent("");
            setContact("");
            setContactNew("");
            setContactVendor("");
            setContactPartner("");
            setContactHome("");
            setContactLender("");
            setContactSellerOther("");
            setContactBuyerOther("");
            setContactTitle("");
            setSelectedSide("");
            setContactValue("");
            setLoader({ isActive: false });
            setToaster({
              types: "Transaction Delete",
              isShow: true,
              toasterBody: response.data.message,
              message: "Transaction Contact Deleted Successfully",
            });
            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 2000);

            const TransactionGetById = async () => {
              await user_service
                .transactionGetById(params.id)
                .then((response) => {
                  if (response) {
                    setTransactionId(response.data);
                  }
                });
            };
            TransactionGetById(params.id);

            document.getElementById("closeModal").click();
          } else {
            setLoader({ isActive: false });
            setToaster({
              types: "error",
              isShow: true,
              toasterBody: response.data.message,
              message: "Error",
            });
            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 1000);
          }
        });
    } catch (error) {
      setLoader({ isActive: false });
      setToaster({
        types: "error",
        isShow: true,
        toasterBody: error.response
          ? error.response.data.message
          : error.message,
        message: "Error",
      });

      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 2000);
    }
  };

  {
    /* <!-- paginate Function Api call Start--> */
  }
  useEffect(() => {
    if (formValues.firstName) {
      SearchGetAll();
    }
  }, [formValues]);

  const SearchGetAll = async () => {
    setIsLoading(true);
    await user_service
      .SearchContactGet(1, 3, formValues.firstName)
      .then((response) => {
        if (response) {
          setIsLoading(false);

          setResults(response.data.data);
          setPageCount(Math.ceil(response.data.totalRecords / 3));
        }
      });
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    let skip = currentPage - 1 + currentPage;
    setLoader({ isActive: true });
    await user_service
      .SearchContactGet(currentPage, 3, formValues.firstName)
      .then((response) => {
        setLoader({ isActive: false });
        if (response) {
          setResults(response.data.data);
          setPageCount(Math.ceil(response.data.totalRecords / 3));
        }
      });
  };

  const handleSearchTransaction = async (id) => {
    await user_service.contactGetById(id).then((response) => {
      setClientId(id);
      setSelect(response.data);
    });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(1);
  };



  const TransactionStep = (stepno, value, title="") => {
    setContactTitle(title);

    if (stepno === "1") {
      setStep1(stepno);
      setRepresent(value);
      setShowPopup(false);
      setShowModal(false);
      setContactSellerOther("");
      setContactBuyerOther("")
    }
    if (stepno === "2") {
      setStep2(stepno);
      setType(value);
      setContactSellerOther("");
      setContactBuyerOther("");
      // setFormValues("");
    }
    if (stepno === "3") {
      setStep3(stepno);
      setPhase(value);
      setContactSellerOther("");
      setContactBuyerOther("");
      // setFormValues("");
    }
    if (stepno === "4") {
      setStep4(stepno);
      setRepresent(value);
      setContactSellerOther("");
      setContactBuyerOther("");
      //  console.log(value);
    }
    if (stepno === "5") {
      setStep5(stepno);
      setContact(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "6") {
      setStep6(stepno);
      setContactValue(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "7") {
      setStep7(stepno);
      setContactNew(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "8") {
      setStep8(stepno);
      setContactVendor(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "9") {
      setStep9(stepno);
      setContactPartner(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "10") {
      setStep10(stepno);
      setContactHome(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "11") {
      setStep11(stepno);
      setContactLender(value);
      setContactSellerOther("");
      setContactBuyerOther("");
    }

    if (stepno === "12") {
      setStep12(stepno);
      setContactSellerOther(value);
      setContactBuyerOther("");

    }

    if (stepno === "13") {
      setStep13(stepno);
      setContactBuyerOther(value);
      setContactSellerOther("");
    }
    else {
      setStep1(stepno);
    }
  };

  const Cancel = () => {
    setSelect("");
  };

  const handleTypeContact = (type, id) => {
    if (type === "private") {
      navigate(`/private-contact/${id}`);
    } else {
      navigate(`/contact-profile/${id}`);
    }
  };

  
  const [selectedinvitedid, setSelectedinvitedid] = useState("");
  const sendinvitationContact = (type, id) => {
    window.alert(`New Feature is coming soon.`);
    //  setSelectedinvitedid(id);
    // window.$('#invitecontact').hide();
    // window.$('#invitecontact').show();
  };

  
  //   const sendContactinvite = async () => {
  //   let arrinvitecontact = [];
    

  //     transactionId.invitecontact.map((invitecontact) => {
  //       if (invitecontact && invitecontact.data._id !== selectedinvitedid) {
  //         const contactinvitecontact = {
  //           contactId: invitecontact.data._id,
  //           acceppted: invitecontact.data.acceppted,
  //           is_active: invitecontact.data.is_active,
  //         };
  //         arrinvitecontact.push(contactinvitecontact);
  //       }else{
  //         setLoader({ isActive: false });
  //           setToaster({
  //             types: "error",
  //             isShow: true,
  //             toasterBody: "This contact is already invited.",
  //             message: "Error",
  //           });
  //           setTimeout(() => {
  //             setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
  //           }, 2000);
  //           return;
  //       }
  //     });
  //     if (selectedinvitedid) {
  //       const newinvitecontact = {
  //         contactId: selectedinvitedid,
  //         acceppted: "1",
  //         is_active: "0",
  //       };
  //       arrinvitecontact.push(newinvitecontact);
  //     }

  //   try {
  //     const userData = {
  //       inviteuser:"inviteuser",
  //       selectedinvitedid:selectedinvitedid,
  //       invitecontact: arrinvitecontact,
  //     };

  //     // console.log(userData);

  //     setLoader({ isActive: true });
  //     await user_service
  //       .TransactionUpdate(params.id, userData)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           const userDatan = {
  //             addedBy: jwt(localStorage.getItem("auth")).id,
  //             agentId: jwt(localStorage.getItem("auth")).id,
  //             transactionId: params.id,
  //             message: "Transaction Contact Invite",
  //             // transaction_property_address: "ADDRESS 2",
  //             note_type: "Contact Update",
  //           };
  //           const responsen = user_service.transactionNotes(userDatan);

  //           setTransactionId(response.data);
            
  //           setSelectedinvitedid("");
  //           setLoader({ isActive: false });
  //           setToaster({
  //             types: "Transaction Updated",
  //             isShow: true,
  //             toasterBody: response.data.message,
  //             message: "Transaction Contact Invite Successfully",
  //           });

  //           setTimeout(() => {
  //             setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
  //           }, 3000);

  //           const TransactionGetById = async () => {
  //             await user_service
  //               .transactionGetById(params.id)
  //               .then((response) => {
  //                 if (response) {
  //                   setTransactionId(response.data);
  //                 }
  //               });
  //           };
  //           TransactionGetById(params.id);

  //           document.getElementById("closeModalinvite").click(); 
  //           document.getElementById("closeModalp").click(); 
  //           document.getElementById("closeModalnew").click(); 
  //           document.getElementById("closeModal").click(); 
            
  //         } else {
  //           setLoader({ isActive: false });
  //           setToaster({
  //             types: "error",
  //             isShow: true,
  //             toasterBody: response.data.message,
  //             message: "Error",
  //           });
  //           setTimeout(() => {
  //             setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
  //           }, 2000);
  //         }
  //       });
  //   } catch (error) {
  //     setLoader({ isActive: false });
  //     setToaster({
  //       types: "error",
  //       isShow: true,
  //       toasterBody: error.response
  //         ? error.response.data.message
  //         : error.message,
  //       message: "Error",
  //     });
  //     setTimeout(() => {
  //       setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
  //     }, 2000);
  //   }
  // };

  const sendContactinvite = async () => {
    let arrinvitecontact = [];
    let isDuplicate = false; // Flag to track duplicates
  
    transactionId.invitecontact.map((invitecontact) => {
      if (isDuplicate) return; // Stop processing if a duplicate is found
  
      if (invitecontact && invitecontact.data._id !== selectedinvitedid) {
        const contactinvitecontact = {
          contactId: invitecontact.data._id,
          acceppted: invitecontact.data.acceppted,
          is_active: invitecontact.data.is_active,
        };
        arrinvitecontact.push(contactinvitecontact);
      } else {
        setLoader({ isActive: false });
        setToaster({
          types: "error",
          isShow: true,
          toasterBody: "This contact is already invited.",
          message: "Error",
        });
        setTimeout(() => {
          setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
        }, 2000);
        isDuplicate = true; // Signal to stop further processing
        return;
      }
    });
  
    // Stop further execution if a duplicate was found
    if (isDuplicate) return;
  
    if (selectedinvitedid) {
      const newinvitecontact = {
        contactId: selectedinvitedid,
        acceppted: "1",
        is_active: "0",
      };
      arrinvitecontact.push(newinvitecontact);
    }
  
    try {
      const userData = {
        inviteuser: "inviteuser",
        selectedinvitedid: selectedinvitedid,
        invitecontact: arrinvitecontact,
      };
  
      setLoader({ isActive: true });
      await user_service
        .TransactionUpdate(params.id, userData)
        .then((response) => {
          if (response.status === 200) {
            const userDatan = {
              addedBy: jwt(localStorage.getItem("auth")).id,
              agentId: jwt(localStorage.getItem("auth")).id,
              transactionId: params.id,
              message: "Transaction Contact Invite",
              note_type: "Contact Update",
            };
            user_service.transactionNotes(userDatan);
  
            setTransactionId(response.data);
            setSelectedinvitedid("");
            setLoader({ isActive: false });
            setToaster({
              types: "Transaction Updated",
              isShow: true,
              toasterBody: response.data.message,
              message: "Transaction Contact Invite Successfully",
            });
  
            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 3000);
  
            const TransactionGetById = async () => {
              const response = await user_service.transactionGetById(params.id);
              if (response) {
                setTransactionId(response.data);
              }
            };
            TransactionGetById();
  
            // Close modals
            ["closeModalinvite", "closeModalp", "closeModalnew", "closeModal"].forEach((id) => {
              const element = document.getElementById(id);
              if (element) element.click();
            });
          } else {
            setLoader({ isActive: false });
            setToaster({
              types: "error",
              isShow: true,
              toasterBody: response.data.message,
              message: "Error",
            });
            setTimeout(() => {
              setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
            }, 2000);
          }
        });
    } catch (error) {
      setLoader({ isActive: false });
      setToaster({
        types: "error",
        isShow: true,
        toasterBody: error.response
          ? error.response.data.message
          : error.message,
        message: "Error",
      });
      setTimeout(() => {
        setToaster((prevToaster) => ({ ...prevToaster, isShow: false }));
      }, 2000);
    }
  };
  

  const [selectedSide, setSelectedSide] = useState(null);

  const handleCheckside = (side) => {
    setSelectedSide(side);
  };

  const transactionOptions = {
    seller: {
      sellerSide: [
        ["1", "seller", "Seller"],
        ["3", "seller_Agent", "Seller's Agent"],
        ["5", "Coordinator", "Seller's Agent Coordinator"],
        ["6", "seller_Title", "Seller's Title Agent"],
        ["9", "seller_partner", "Seller's Agent Partner"],
        ["7", "seller_Attorney", "Seller's Attorney"],
        ["12", "seller_other", "Other"],

      ],
      buyerSide: [
        ["2", "buyer", "Buyer"],
        ["4", "buyer_Agent", "Buyer's Agent"],
        ["10", "home_Warrenty", "Home Warranty"],
        ["11", "buyer_lender", "Buyer's Lender"],
        ["8", "vendorNew", "Vendor"],
        ["13", "other_buyer", "Other"],

      ],
    },
    buyer: {
      buyerSide: [
        ["1", "buyer", "Buyer"],
        ["3", "buyer_Agent", "Buyer's Agent"],
        ["5", "Coordinator", "Buyer Agent's Coordinator"],
        ["11", "buyer_lender", "Buyer's Lender"],
        ["6", "buyer_Title", "Buyer's Title Agent"],
        ["9", "buyer_partner", "Buyer's Agent Partner"],
        ["7", "buyer_Attorney", "Buyer's Attorney"],
        ["13", "other_buyer", "Other"],
      ],
      sellerSide: [
        ["2", "seller", "Seller"],
        ["4", "seller_Agent", "Seller's Agent"],
        ["10", "home_Warrenty", "Home Warranty"],
        ["8", "vendorNew", "Vendor"],
        ["12", "seller_other", "Other"],
      ],
    },
    both: {
      sellerSide: [
        ["1", "sellersale", "Seller"],
        ["3", "sale_Agent", "Partner"],
        ["5", "Coordinator", "Seller's Agent's Coordinator"],
        ["12", "seller_other", "Other"],
      ],
      buyerSide: [
        ["2", "buyersale", "Buyer"],
        ["4", "buy_Agent", "Buyer's Agent"],
        ["6", "Vendor", "Vendor"],
        ["13", "other_buyer", "Other"],
      ],
    },

    referral: {
      sellerSide: [
        ["1", "referralsale", "Seller"],
        ["3", "referral_Agent", "Partner"],
        ["5", "Coordinator", "Seller's Agent's Coordinator"],
        ["12", "seller_other", "Other"],

      ],
      buyerSide: [
        ["2", "referral_sellerAgent", "Seller's Agent"],
        ["4", "referralbuy_Agent", "Buyer's Agent"],
        ["6", "Vendor", "Vendor"],
        ["13", "other_buyer", "Other"],
      ],
    },
  };
  
  const [otherSideValue, setOtherSideValue] = useState("");
  const [otherSideBuyer, setOtherSideBuyer] = useState("");

  const handleInputChange = (event) => {
    setOtherSideValue(event.target.value);
  };

  const handleInputBuyer = (event) => {
    setOtherSideBuyer(event.target.value);
  };
  
  
  return (
    <div className="bg-secondary float-left w-100 pt-4 mb-4">
      <Loader isActive={isActive} />
      {isShow && (
        <Toaster
          types={types}
          isShow={isShow}
          toasterBody={toasterBody}
          message={message}
        />
      )}
      <main className="page-wrapper">
        {/* <!-- Page container--> */}
        <div className="content-overlay transaction_tab_view">
          <div className="row">
            <AllTab />
            <div className="col-md-12"> 
              {/* <div className="d-flex align-items-center justify-content-start mb-3">
                <h3 className="text-white mb-0">Contact</h3>
              </div> */}
              <div className="">
                <div className="bg-light border rounded-3 mb-4 p-3">
                  <div className="row">
                    <div className="col-md-12">
                      <h3 className="text-left mb-2">Transaction Parties</h3>
                      <p className="mb-0 ms-sm-0 ms-0" id="text-document">
                          Achieving a successful real estate transaction requires teamwork. Effective communication and collaboration among all parties are key to navigating the process smoothly. 
                          Listing everyone involved in the transaction on this page—including inspectors, lenders, and other vendors—also makes it easier to access their information when needed.
                      </p>
                    </div>
                    {/* <div className="col-md-3 py-2 justify-content-end d-flex align-items-center">
                      <a className="btn btn-primary btn-sm pull-right" href="#">
                        <i className="fi-plus me-2"></i>Share Transaction
                      </a>
                    </div> */}
                  </div>
                </div>
                {/* <StatusBar /> */}

                <div className="float-start w-100 mt-3">
                  {transactionId.represent === "seller" ? (
                    <div className="row">
                      <div className="col-md-12">
                        <h4 className="text-light">Seller's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 seller float-start w-100">
                            {transactionId &&
                            transactionId.contact1 &&
                            transactionId.contact1.length > 0 ? (
                              transactionId.contact1.map((item) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={item?.data?._id}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setShowPopup(true);
                                                      setRepresent(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setShowPopup(true);
                                                  setRepresent(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between "
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink className="card-title mt-0">
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}{" "}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                      <div className="ms-5">
                                          <h6 className="mb-0">Seller</h6>
                                      </div>
                                    </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    className=""
                                                    onClick={() =>
                                                      TransactionStep("1", "seller", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      seller</h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                className=""
                                                onClick={() =>
                                                  TransactionStep("1", "seller", "Seller")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  seller </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setShowPopup(true);
                                                        setRepresent(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setShowPopup(true);
                                                    setRepresent(item?.data?._id);
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div>


                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "sale_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    className=""
                                                    onClick={() =>
                                                      TransactionStep("1", "seller", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      seller </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                className=""
                                                onClick={() =>
                                                  TransactionStep("1", "seller", "Seller")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  seller </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    className=""
                                                    onClick={() =>
                                                      TransactionStep("1", "seller", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      seller </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                className=""
                                                onClick={() =>
                                                  TransactionStep("1", "seller", "Seller")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  seller </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {showPopup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "seller",
                                          "contact1"
                                        )
                                      }
                                    >
                                      <button
                                        onClick={() => {
                                          setShowModal(true);
                                          setShowPopup(true);
                                        }}
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#conactPopUp"
                                        className="btn btn-primary btn-sm"
                                      >
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  ms-2"
                                      onClick={() => handleCancel(represent)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {showModal && (
                              <div
                                className="modal"
                                role="dialog"
                                id="conactPopUp"
                              >
                                <div className="modal-dialog" role="document">
                                  <div className="modal-content">
                                    <div className="modal-body row">
                                      <div>
                                        <h4>
                                          {" "}
                                          To remove this contact, please add
                                          another client first.
                                        </h4>
                                        <button
                                          type="button"
                                          className="btn btn-default btn btn-primary btn-sm pull-right"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Ok
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller's Agent</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Seller's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("3", "seller_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>
                                            Seller's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("3", "seller_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Seller's
                                        Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact3 &&
                            transactionId.contact3.length > 0 ? (
                              transactionId.contact3.map((item, index) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={index}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          
                                          <i
                                            onClick={() => {
                                              setPopupPhase(true);
                                              setPhase(item.data._id);
                                            }}
                                            className="h2 fi-trash opacity-80 pull-left"
                                          ></i>
                                        </div>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent</h6>
                                        </div>
                                    </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <i className="fi-plus me-2"></i>Seller's
                                            Agent
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("3", "seller_Agent", "Seller's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                  <h6 className="p-0 m-0">
                                                    <i className="fi-plus me-2"></i>
                                                    Seller's Agent
                                                  </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("3", "seller_Agent", "Seller's Agent")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                
                                                <h6 className="p-0 m-0">

                                                <i className="fi-plus me-2"></i>Seller's
                                                Agent
                                                </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}   
                                      </div>
                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            
                                            <i
                                              onClick={() => {
                                                setPopupPhase(true);
                                                setPhase(item.data._id);
                                              }}
                                              className="h2 fi-trash opacity-80 pull-left"
                                            ></i>
                                          </span>
                                        )}

                                    </div>  

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "sale_referral" ? (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <i className="fi-plus me-2"></i>Seller's
                                              Agent
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("3", "seller_Agent", "Seller's Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                            <h6 className="p-0 m-0">
                                                              <i className="fi-plus me-2"></i>
                                                              Seller's Agent
                                                            </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("3", "seller_Agent", "Seller's Agent")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                        <h6 className="p-0 m-0">
                                                  <i className="fi-plus me-2"></i>Seller's
                                                  Agent
                                                  </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <i className="fi-plus me-2"></i>Seller's
                                              Agent
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("3", "seller_Agent", "Seller's Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                              <h6 className="p-0 m-0">
                                                                <i className="fi-plus me-2"></i>
                                                                Seller's Agent
                                                              </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("3", "seller_Agent", "Seller's Agent")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0">
                                                  <i className="fi-plus me-2"></i>Seller's
                                                  Agent
                                                  </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupPhase && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          phase,
                                          "seller_Agent",
                                          "contact3"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">
                                Seller's Agent's Coordinator
                              </h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add
                                    Coordinator
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <div
                                        onClick={() =>
                                          TransactionStep("5", "Coordinator")
                                        }
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm"
                                          data-toggle="modal"
                                          data-target="#addcontact"
                                        >
                                          <i className="fi-plus me-2"></i>Add
                                          Coordinator
                                        </button>
                                      </div>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("5", "Coordinator")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Coordinator
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact5 &&
                            transactionId.contact5.length > 0 ? (
                              transactionId.contact5.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContact(true);
                                                      setContact(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContact(true);
                                                  setContact(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                        
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>

                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent's Coordinator</h6>
                                        </div>
                                      </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Coordinator </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("5", "Coordinator", "seller's Agent Coordinator")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Coordinator </h6>
                                                  </button>
                                                </div>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("5", "Coordinator", "seller's Agent Coordinator")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Coordinator </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                        </div>
                                        {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContact(true);
                                                        setContact(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupContact(true);
                                                    setContact(item.data._id);
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                      </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                          Coordinator </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <div
                                              onClick={() =>
                                                TransactionStep("5", "Coordinator", "seller's Agent Coordinator")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Coordinator </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("5", "Coordinator", "seller's Agent Coordinator")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Coordinator </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContact && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contact,
                                          "Coordinator",
                                          "contact5"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller's Title Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Seller's
                                    Title Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("6", "seller_Title")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Seller's Title Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("6", "seller_Title")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Seller's Title Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact6 &&
                            transactionId.contact6.length > 0 ? (
                              transactionId.contact6.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupValue(true);
                                                  setContactValue(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {" "}
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Title Agent</h6>
                                        </div>
                                      </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>

                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                                Title Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("6", "seller_Title", "Seller's Title Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Title Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("6", "seller_Title", "Seller's Title Agent") 
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Title Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>

                                        {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                      <i
                                                        onClick={() => {
                                                          setPopupValue(true);
                                                          setContactValue(
                                                            item?.data?._id
                                                          );
                                                        }}
                                                        className="h2 fi-trash opacity-80 pull-left"
                                                      ></i>
                                                      <i
                                                        className="h2 fi-edit opacity-80 pull-right"
                                                        onClick={() =>
                                                          TransactionEdit(
                                                            item?.data?.contactType,
                                                            item?.data?._id
                                                          )
                                                        }
                                                      ></i>
                                                    </span>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </span>
                                              )}
                                            </>
                                          )}

                                      </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                   {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Title Agent </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep("6", "seller_Title", "Seller's Title Agent")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Title Agent </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("6", "seller_Title", "Seller's Title Agent")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Title Agent </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupValue && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactValue,
                                          "seller_Title",
                                          "contact6"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact9 &&
                            transactionId.contact9.length > 0 ? (
                              transactionId.contact9.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">Seller's Agent Partner</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                                  Agent Partner </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep(
                                                            "9",
                                                            "seller_partner", "Seller's Agent Partner"
                                                          )
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Seller's Agent Partner </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("9", "seller_partner", "Seller's Agent Partner")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller's Agent Partner </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}    
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContactPartner(
                                                              true
                                                            );
                                                            setContactPartner(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactPartner(true);
                                                        setContactPartner(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Agent Partner </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "9",
                                                    "seller_partner", "Seller's Agent Partner"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Agent Partner </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("9", "seller_partner", "Seller's Agent Partner")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Agent Partner </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactPartner && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactPartner,
                                          "seller_partner",
                                          "contact9"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact7 &&
                            transactionId.contact7.length > 0 ? (
                              transactionId.contact7.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">Seller's Attorney</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                                Attorney </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "7",
                                                          "seller_Attorney", "Seller's Attorney"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Attorney </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Attorney </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContactAttoney(
                                                              true
                                                            );
                                                            setContactNew(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactAttoney(true);
                                                        setContactNew(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Attorney </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "7",
                                                    "seller_Attorney", "Seller's Attorney"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Attorney </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Attorney </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactAttoney && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactNew,
                                          "seller_Attorney",
                                          "contact7"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact12 &&
                            transactionId.contact12.length > 0 ? (
                              transactionId.contact12.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {/* <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Other</h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "7",
                                                          "seller_Attorney", "Seller's Attorney"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Attorney </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Attorney </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                          </div> */}
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupSellerOther(
                                                              true
                                                            );
                                                            setContactSellerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupSellerOther(true);
                                                        setContactSellerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>  
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Attorney </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "7",
                                                    "seller_Attorney", "Seller's Attorney"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Attorney </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Attorney </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                              {popupSellerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactSellerOther,
                                          "seller_Other",
                                          "contact12"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                           {/* default add contact button section */}
                           <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <h4 className="text-light">Buyer's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 buyer float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("2", "buyer")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addContactseller"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("2", "buyer")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addContactseller"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact2 &&
                            transactionId.contact2.length > 0 ? (
                              transactionId.contact2.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopup(true);
                                                      setType(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopup(true);
                                                  setType(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                      
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                            onClick={() =>
                                              handleTypeContact(
                                                item?.data?.contactType,
                                                item?.data?._id
                                              )
                                            }>

                                            {/* <img className="pull-left" src={item?.data?.image || "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"} alt="avatar" /> */}
                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {" "}
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">Buyer</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                                <div>
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    title="Your transaction was completed"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                                  </button>
                                                </div>
                                              ) : (
                                                <>
                                                  {transactionFundingRequest?.invoice_url ? (
                                                    localStorage.getItem("auth") &&
                                                    jwt(localStorage.getItem("auth"))
                                                      .contactType == "admin" ? (
                                                      <>
                                                        <div
                                                          onClick={() =>
                                                            TransactionStep("2", "buyer", "Buyer")
                                                          }
                                                        >
                                                          <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            data-toggle="modal"
                                                            data-target="#addContactseller"
                                                          >
                                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                            Buyer </h6>
                                                          </button>
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <></>
                                                    )
                                                  ) : (
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("2", "buyer", "Buyer")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer </h6>
                                                      </button>
                                                    </div>
                                                  )}
                                                </>
                                              )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopup(true);
                                                            setType(item.data._id);
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopup(true);
                                                        setType(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "sale_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("2", "buyer", "Buyer")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("2", "buyer", "Buyer")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addContactseller"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("2", "buyer", "Buyer")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("2", "buyer", "Buyer")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addContactseller"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(type, "buyer", "contact2")
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => handleCancel(type)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Agent</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("4", "buyer_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("4", "buyer_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer's Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact4 &&
                            transactionId.contact4.length > 0 ? (
                              transactionId.contact4.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupRepresent(true);
                                                      setRepresent(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupRepresent(true);
                                                  setRepresent(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Agent</h6>
                                        </div>
                                    </div>   
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                      <i
                                                        onClick={() => {
                                                          setPopupRepresent(true);
                                                          setRepresent(
                                                            item.data._id
                                                          );
                                                        }}
                                                        className="h2 fi-trash opacity-80 pull-left"
                                                      ></i>
                                                      <i
                                                        className="h2 fi-edit opacity-80 pull-right"
                                                        onClick={() =>
                                                          TransactionEdit(
                                                            item?.data?.contactType,
                                                            item?.data?._id
                                                          )
                                                        }
                                                      ></i>
                                                    </span>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupRepresent(true);
                                                      setRepresent(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </span>
                                              )}
                                            </>
                                          )} 

                                    </div> 

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "sale_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                              Agent </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Agent </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Agent </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "buyer_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupRepresent && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "buyer_Agent",
                                          "contact4"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Home Warranty</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Home
                                    Warranty
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "10",
                                              "home_Warrenty"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Home Warranty
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("10", "home_Warrenty")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add Home
                                        Warranty
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact10 &&
                            transactionId.contact10.length > 0 ? (
                              transactionId.contact10.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactHome(true);
                                                      setContactHome(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactHome(true);
                                                  setContactHome(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                      onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Home Warranty</h6>
                                        </div>
                                      </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>

                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                Warranty </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "10",
                                                          "home_Warrenty", "Home Warranty"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Home Warranty </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("10", "home_Warrenty", "Home Warranty")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                    Warranty </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>

                                        {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                      <i
                                                        onClick={() => {
                                                          setPopupContactHome(true);
                                                          setContactHome(
                                                            item?.data?._id
                                                          );
                                                        }}
                                                        className="h2 fi-trash opacity-80 pull-left"
                                                      ></i>
                                                      <i
                                                        className="h2 fi-edit opacity-80 pull-right"
                                                        onClick={() =>
                                                          TransactionEdit(
                                                            item?.data?.contactType,
                                                            item?.data?._id
                                                          )
                                                        }
                                                      ></i>
                                                    </span>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactHome(true);
                                                      setContactHome(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </span>
                                              )}
                                            </>
                                          )}

                                      </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                          Warranty </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "10",
                                                    "home_Warrenty", "Home Warranty"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Home Warranty </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("10", "home_Warrenty", "Home Warranty")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                              Warranty </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactHome && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactHome,
                                          "home_Warrenty",
                                          "contact10"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Lender</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Buyer's
                                    Lender
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "11",
                                              "buyer_lender"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Buyer's Lender
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("11", "buyer_lender")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Buyer's Lender
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact11 &&
                            transactionId.contact11.length > 0 ? (
                              transactionId.contact11.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupLender(true);
                                                      setContactLender(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupLender(true);
                                                  setContactLender(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                      onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>

                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Lender</h6>
                                        </div>
                                    </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                              Lender </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep(
                                                        "11",
                                                        "buyer_lender", "Buyer's Lender"
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Lender </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("11", "buyer_lender", "Buyer's Lender")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Lender </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>

                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupLender(true);
                                                        setContactLender(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupLender(true);
                                                    setContactLender(
                                                      item?.data?._id
                                                    );
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                          Lender </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "11",
                                                    "buyer_lender", "Buyer's Lender"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Lender </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("11", "buyer_lender", "Buyer's Lender")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Buyer's Lender </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupLender && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactLender,
                                          "buyer_lender",
                                          "contact11"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Vendor</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Vendor
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("8", "vendorNew")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Vendor
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("8", "vendorNew")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Vendor
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact8 &&
                            transactionId.contact8.length > 0 ? (
                              transactionId.contact8.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactVendor(
                                                        true
                                                      );
                                                      setContactVendor(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactVendor(true);
                                                  setContactVendor(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </span>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Vendor</h6>
                                        </div>
                                    </div> 
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("8", "vendorNew", "Vendor")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Vendor </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("8", "vendorNew", "Vendor")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Vendor </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>

                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactVendor(
                                                          true
                                                        );
                                                        setContactVendor(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupContactVendor(true);
                                                    setContactVendor(
                                                      item?.data?._id
                                                    );
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div> 
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("8", "vendorNew", "Vendor")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Vendor </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("8", "vendorNew", "Vendor")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Vendor </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactVendor && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactVendor,
                                          "vendorNew",
                                          "contact8"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact13 &&
                            transactionId.contact13.length > 0 ? (
                              transactionId.contact13.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupBuyerOther(
                                                              true
                                                            );
                                                            setContactBuyerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupBuyerOther(true);
                                                        setContactBuyerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                             ""
                            )}

                              {popupBuyerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactBuyerOther,
                                          "other_buyer",
                                          "contact13"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}




                  {transactionId.represent === "buyer" ? (
                    <div className="row">
                      <div className="col-md-12">
                        <h4 className="text-light">Buyer's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 buyer float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("1", "buyer")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("1", "buyer")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact1 &&
                            transactionId.contact1.length > 0 ? (
                              transactionId.contact1.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setShowPopup(true);
                                                      setRepresent(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setShowPopup(true);
                                                  setRepresent(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                          onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />
                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {" "}
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>
                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}



                                            </span>
                                          </div>
                                          <div className="ms-5">
                                            <h6 className="mb-0">Buyer</h6>
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("1", "buyer", "Buyer")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Buyer  </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("1", "buyer", "Buyer")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end m-0 ">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end m-0">
                                                        <i
                                                          onClick={() => {
                                                            setShowPopup(true);
                                                            setRepresent(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end m-0">
                                                    <i
                                                      onClick={() => {
                                                        setShowPopup(true);
                                                        setRepresent(item?.data?._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <> 
                                {transactionId.type === "buy_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("1", "buyer", "Buyer")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("1", "buyer", "Buyer")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("1", "buyer", "Buyer")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("1", "buyer", "Buyer")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {showPopup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "buyer",
                                          "contact1"
                                        )
                                      }
                                    >
                                      <button
                                        onClick={() => {
                                          setShowModal(true);
                                          setShowPopup(false);
                                        }}
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#conactPopUp"
                                        className="btn btn-primary btn-sm"
                                      >
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {showModal && (
                              <div
                                className="modal"
                                role="dialog"
                                id="conactPopUp"
                              >
                                <div className="modal-dialog" role="document">
                                  <div className="modal-content">
                                    <div className="modal-body row">
                                      <div>
                                        <h4>
                                          {" "}
                                          To remove this contact, please add
                                          another client first.
                                        </h4>
                                        <button
                                          type="button"
                                          className="btn btn-default btn btn-primary btn-sm pull-right mt-3"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Ok
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Agent</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("3", "buyer_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("3", "buyer_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer's Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact3 &&
                            transactionId.contact3.length > 0 ? (
                              transactionId.contact3.map((item, index) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={index}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <div className="edit_delete_action d-flex align-items-center justify-content-between">
                                         <i
                                            onClick={() => {
                                              setPopupPhase(true);
                                              setPhase(item.data._id);
                                            }}
                                            className="h2 fi-trash opacity-80 pull-left"
                                          ></i>
                                        </div>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto" 
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>

                                        </div>
                                          <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Agent</h6>
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>

                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                  Agent </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Buyer's Agent </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Agent </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>

                                          {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end ms-4">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <span className="edit_delete_action d-flex align-items-center justify-content-between">
                                            <i
                                                onClick={() => {
                                                  setPopupPhase(true);
                                                  setPhase(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                            </span>
                                          )}
                                          
                                          </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "buy_referral" ? (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("3", "buyer_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupPhase && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          phase,
                                          "buyer_Agent",
                                          "contact3"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">
                                Buyer Agent's Coordinator
                              </h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add
                                    Coordinator
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("5", "Coordinator")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Coordinator
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("5", "Coordinator")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Coordinator
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact5 &&
                            transactionId.contact5.length > 0 ? (
                              transactionId.contact5.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContact(true);
                                                      setContact(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContact(true);
                                                  setContact(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>

                                    </div>
                                      <div className="ms-5">
                                        <h6 className="mb-0"> Buyer Agent's Coordinator</h6>
                                      </div>
                                    </div>


                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>

                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Coordinator </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("5", "Coordinator", "Buyer Agent's Coordinator")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Coordinator </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("5", "Coordinator", "Buyer Agent's Coordinator")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Coordinator </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContact(true);
                                                            setContact(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContact(true);
                                                        setContact(item?.data?._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                            Coordinator </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("5", "Coordinator", "Buyer Agent's Coordinator")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Coordinator </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("5", "Coordinator", "Buyer Agent's Coordinator")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Coordinator </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContact && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contact,
                                          "Coordinator",
                                          "contact5"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Lender</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Buyer's
                                    Lender
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "11",
                                              "buyer_lender"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Buyer's Lender
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("11", "buyer_lender")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Buyer's Lender
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact11 &&
                            transactionId.contact11.length > 0 ? (
                              transactionId.contact11.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupLender(true);
                                                      setContactLender(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupLender(true);
                                                  setContactLender(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Buyer's Lender</h6>
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                                  Lender </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep(
                                                            "11",
                                                            "buyer_lender", "Buyer's Lender"
                                                          )
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Buyer's Lender </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("11", "buyer_lender", "Buyer's Lender")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Lender </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>

                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupLender(true);
                                                            setContactLender(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupLender(true);
                                                        setContactLender(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                            Lender </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "11",
                                                      "buyer_lender", "Buyer's Lender"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Lender </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("11", "buyer_lender", "Buyer's Lender")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Buyer's Lender </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupLender && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactLender,
                                          "buyer_lender",
                                          "contact11"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Title Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Buyer's
                                    Title Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("6", "buyer_Title")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Buyer's Title Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("6", "buyer_Title")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Buyer's Title Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact6 &&
                            transactionId.contact6.length > 0 ? (
                              transactionId.contact6.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupValue(true);
                                                  setContactValue(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Title Agent</h6>
                                        </div>
                                    </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>

                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                              Title Agent </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("6", "buyer_Title", "Buyer's Title Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Title Agent </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("6", "buyer_Title", "Buyer's Title Agent")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Title Agent </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {transactionId.filing ===
                                      "filed_complted" ? (
                                        <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </span>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </span>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupValue(true);
                                                  setContactValue(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </span>
                                          )}
                                        </>
                                      )}  

                                    </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                            Title Agent </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("6", "buyer_Title", "Buyer's Title Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Title Agent </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("6", "buyer_Title", "Buyer's Title Agent")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Buyer's Title Agent </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupValue && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactValue,
                                          "buyer_Title",
                                          "contact6"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Agent Partner</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Buyer's
                                    Agent Partner
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "9",
                                              "buyer_partner"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Buyer's Agent Partner
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("9", "buyer_partner")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Buyer's Agent Partner
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact9 &&
                            transactionId.contact9.length > 0 ? (
                              transactionId.contact9.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactPartner(
                                                        true
                                                      );
                                                      setContactPartner(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactPartner(true);
                                                  setContactPartner(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>

                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Agent Partner</h6>
                                        </div>
                                    </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                              Agent Partner </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep(
                                                        "9",
                                                        "buyer_partner", "Buyer's Agent Partner"
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Agent Partner </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("9", "buyer_partner", "Buyer's Agent Partner")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Agent Partner </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactPartner(
                                                          true
                                                        );
                                                        setContactPartner(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupContactPartner(true);
                                                    setContactPartner(
                                                      item?.data?._id
                                                    );
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                            Agent Partner </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "9",
                                                      "buyer_partner", "Buyer's Agent Partner"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent Partner </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("9", "buyer_partner", "Buyer's Agent Partner")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Buyer's Agent Partner </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactPartner && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactPartner,
                                          "buyer_partner",
                                          "contact9"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Attorney</h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Buyer's
                                    Attorney
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "7",
                                              "buyer_Attorney"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Buyer's Attorney
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("7", "buyer_Attorney")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Buyer's Attorney
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact7 &&
                            transactionId.contact7.length > 0 ? (
                              transactionId.contact7.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactAttoney(
                                                        true
                                                      );
                                                      setContactNew(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactAttoney(true);
                                                  setContactNew(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>

                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Attorney</h6>
                                        </div>
                                      </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                                  Attorney </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep(
                                                            "7",
                                                            "buyer_Attorney", "Buyer's Attorney"
                                                          )
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Buyer's Attorney </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("7", "buyer_Attorney", "Buyer's Attorney")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Attorney </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>

                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContactAttoney(
                                                              true
                                                            );
                                                            setContactNew(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactAttoney(true);
                                                        setContactNew(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                      </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Buyer's
                                            Attorney </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "7",
                                                      "buyer_Attorney", "Buyer's Attorney"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Attorney </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("7", "buyer_Attorney", "Buyer's Attorney")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Buyer's Attorney </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactAttoney && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactNew,
                                          "buyer_Attorney",
                                          "contact7"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact13 &&
                            transactionId.contact13.length > 0 ? (
                              transactionId.contact13.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupBuyerOther(
                                                              true
                                                            );
                                                            setContactBuyerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupBuyerOther(true);
                                                        setContactBuyerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                             ""
                            )}

                              {popupBuyerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactBuyerOther,
                                          "other_buyer",
                                          "contact13"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>

                        </div>
                      </div>


                      <div className="col-md-12">
                        <h4 className="text-light">Seller's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 sellet float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add seller
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("2", "seller")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addContactseller"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            seller
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("2", "seller")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addContactseller"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        seller
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact2 &&
                            transactionId.contact2.length > 0 ? (
                              transactionId.contact2.map((item) => (
                                <div className="card bg-secondary mt-0 mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopup(true);
                                                      setType(item?.data?._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopup(true);
                                                  setType(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                          <img className="pull-left" src={item?.data?.image || "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"} alt="avatar" />
                                          <span>
                                            <NavLink
                                              // to={`/contact-profile/${item?.data?._id}`}
                                              className="card-title mt-0"
                                            >
                                              <h6 className="mb-1">
                                                {" "}
                                                {item?.data?.firstName}&nbsp;
                                                {item?.data?.lastName}
                                              </h6>
                                            </NavLink>
                                            <p className="mb-1">
                                              {item?.data?.company}
                                            </p>

                                            {item?.data?.phone ? (
                                              <h6 className="mb-0">
                                                <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                {item?.data?.phone}
                                              </h6>
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Seller</h6>
                                          </div>
                                      </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("2", "seller", "Seller")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addContactseller"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Seller </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("2", "seller", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopup(true);
                                                            setType(item?.data?._id);
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopup(true);
                                                        setType(item?.data?._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                      </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "buy_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                      <p className="p-0">Not Selected.</p>
                                      <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("2", "seller", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("2", "seller", "Seller")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addContactseller"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("2", "seller", "Seller")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("2", "seller", "Seller")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addContactseller"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(type, "seller", "contact2")
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No, cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller's Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add seller's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("4", "seller_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            seller's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("4", "seller_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        seller's Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact4 &&
                            transactionId.contact4.length > 0 ? (
                              transactionId.contact4.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupRepresent(true);
                                                      setRepresent(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupRepresent(true);
                                                  setRepresent(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>

                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent</h6>
                                        </div>
                                      </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller's
                                                  Agent </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Seller's Agent </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller's Agent </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupRepresent(true);
                                                            setRepresent(
                                                              item.data._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupRepresent(true);
                                                        setRepresent(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "buy_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "seller_Agent", "Seller's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupRepresent && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "seller_Agent",
                                          "contact4"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Home Warranty</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Home
                                    Warranty
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "10",
                                              "home_Warrenty"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Home Warranty
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("10", "home_Warrenty")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add Home
                                        Warranty
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact10 &&
                            transactionId.contact10.length > 0 ? (
                              transactionId.contact10.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactHome(true);
                                                      setContactHome(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactHome(true);
                                                  setContactHome(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Home Warranty</h6>
                                        </div>
                                      </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                           {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                  Warranty </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep(
                                                            "10",
                                                            "home_Warrenty", "Home Warranty"
                                                          )
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Home Warranty </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("10", "home_Warrenty", "Home Warranty")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                      Warranty </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContactHome(true);
                                                            setContactHome(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactHome(true);
                                                        setContactHome(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                Warranty </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "10",
                                                          "home_Warrenty", "Home Warranty"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Home Warranty </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("10", "home_Warrenty", "Home Warranty")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Home
                                                    Warranty </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactHome && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactHome,
                                          "home_Warrenty",
                                          "contact10"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Vendor</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Vendor
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("8", "vendorNew")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Vendor
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("8", "vendorNew")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Vendor
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact8 &&
                            transactionId.contact8.length > 0 ? (
                              transactionId.contact8.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContactVendor(
                                                        true
                                                      );
                                                      setContactVendor(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContactVendor(true);
                                                  setContactVendor(
                                                    item?.data?._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                      <div className="ms-5">
                                          <h6 className="mb-0">Vendor</h6>
                                      </div>
                                    </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("8", "vendorNew", "Vendor")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Vendor </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("8", "vendorNew", "Vendor")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Vendor </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContactVendor(
                                                              true
                                                            );
                                                            setContactVendor(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContactVendor(true);
                                                        setContactVendor(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}
                                      </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("8", "vendorNew", "Vendor")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Vendor </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("8", "vendorNew", "Vendor")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Vendor </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContactVendor && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactVendor,
                                          "vendorNew",
                                          "contact8"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact12 &&
                            transactionId.contact12.length > 0 ? (
                              transactionId.contact12.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupSellerOther(
                                                              true
                                                            );
                                                            setContactSellerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupSellerOther(true);
                                                        setContactSellerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>  
                              </>
                            )}

                              {popupSellerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactSellerOther,
                                          "seller_Other",
                                          "contact12"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {transactionId.represent === "both" ? (
                    <div className="row">
                      <div className="col-md-12">

                        <h4 className="text-light">Seller's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 seller float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 classNmae="mb-0">Seller</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add seller
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          className="mt-"
                                          onClick={() =>
                                            TransactionStep("1", "sellersale")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            seller
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      className="mt-3"
                                      onClick={() =>
                                        TransactionStep("1", "sellersale")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        seller
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact1 &&
                            transactionId.contact1.length > 0 ? (
                              transactionId.contact1.map((item) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={item?.data?._id}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setShowPopup(true);
                                                      setRepresent(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setShowPopup(true);
                                                  setRepresent(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>
                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>
                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Seller</h6>
                                          </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        className="mt-3"
                                                        onClick={() =>
                                                          TransactionStep("1", "sellersale", "Seller")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Seller </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    className="mt-3"
                                                    onClick={() =>
                                                      TransactionStep("1", "sellersale", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setShowPopup(true);
                                                            setRepresent(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setShowPopup(true);
                                                        setRepresent(item?.data?._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>  
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "both_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      className="mt-0"
                                                      onClick={() =>
                                                        TransactionStep("1", "sellersale", "Seller")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  className="mt-0"
                                                  onClick={() =>
                                                    TransactionStep("1", "sellersale", "Seller")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      className="mt-0"
                                                      onClick={() =>
                                                        TransactionStep("1", "sellersale", "Seller")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  className="mt-0"
                                                  onClick={() =>
                                                    TransactionStep("1", "sellersale", "Seller")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {showPopup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "sellersale",
                                          "contact1"
                                        )
                                      }
                                    >
                                      <button
                                        onClick={() => {
                                          setShowModal(true);
                                          setShowPopup(true);
                                        }}
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#conactPopUp"
                                        className="btn btn-primary btn-sm"
                                      >
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  ms-2"
                                      onClick={() => handleCancel(represent)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {showModal && (
                              <div
                                className="modal"
                                role="dialog"
                                id="conactPopUp"
                              >
                                <div className="modal-dialog" role="document">
                                  <div className="modal-content">
                                    <div className="modal-body row">
                                      <div>
                                        <h4>
                                          {" "}
                                          To remove this contact, please add
                                          another client first.
                                        </h4>
                                        <button
                                          type="button"
                                          className="btn btn-default btn btn-primary btn-sm pull-right"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Ok
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller's Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Partner
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("3", "sale_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Partner
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("3", "sale_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Partner
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact3 &&
                            transactionId.contact3.length > 0 ? (
                              transactionId.contact3.map((item, index) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={index}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          
                                          <i
                                            onClick={() => {
                                              setPopupPhase(true);
                                              setPhase(item.data._id);
                                            }}
                                            className="h2 fi-trash opacity-80 pull-left"
                                          ></i>
                                        </div>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                          <img
                                            className="pull-left"
                                            src={
                                              item?.data?.image ||
                                              "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                            }
                                            alt="avatar"
                                          />

                                          <span>
                                            <NavLink
                                              // to={`/contact-profile/${item?.data?._id}`}
                                              className="card-title mt-0"
                                            >
                                              <h6 className="mb-1">
                                                {item?.data?.firstName}&nbsp;
                                                {item?.data?.lastName}
                                              </h6>
                                            </NavLink>
                                            <p className="mb-1">
                                              {item?.data?.company}
                                            </p>
                                            {item?.data?.phone ? (
                                              <h6 className="mb-0">
                                                <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                {item?.data?.phone}
                                              </h6>
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent</h6>
                                        </div>
                                      </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Partner </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("3", "sale_Agent", "Partner")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Partner </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("3", "sale_Agent", "Partner")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Partner </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              {/* {index > 0 && ( 
                                                <> */}
                                              <i
                                                onClick={() => {
                                                  setPopupPhase(true);
                                                  setPhase(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              {/* <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i> */}
                                              {/* </>
                                              )} */}
                                            </span>
                                          )}

                                      </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "both_referral" ? (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Partner </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("3", "sale_Agent", "Partner")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Partner </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("3", "sale_Agent", "Partner")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Partner </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Partner </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("3", "sale_Agent", "Partner")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Partner </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("3", "sale_Agent", "Partner")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Partner </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupPhase && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  {/* buyersallerbuyer_Agent */}
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          phase,
                                          "sale_Agent",
                                          "contact3"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">
                                Seller's Agent's Coordinator
                              </h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add
                                    Coordinator
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("5", "Coordinator")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Coordinator
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("5", "Coordinator")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Coordinator
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact5 &&
                            transactionId.contact5.length > 0 ? (
                              transactionId.contact5.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContact(true);
                                                      setContact(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContact(true);
                                                  setContact(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>
                                          <img
                                            className="pull-left"
                                            src={
                                              item?.data?.image ||
                                              "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                            }
                                            alt="avatar"
                                          />

                                          <span>
                                            <NavLink
                                              // to={`/contact-profile/${item?.data?._id}`}
                                              className="card-title mt-0"
                                            >
                                              <h6 className="mb-1">
                                                {item?.data?.firstName}&nbsp;
                                                {item?.data?.lastName}
                                              </h6>
                                            </NavLink>
                                            <p className="mb-1">
                                              {item?.data?.company}
                                            </p>
                                            {item?.data?.phone ? (
                                              <h6 className="mb-0">
                                                <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                {item?.data?.phone}
                                              </h6>
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Seller's Agent's Coordinator</h6>
                                          </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Coordinator </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Coordinator </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Coordinator </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>

                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupContact(true);
                                                            setContact(item.data._id);
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupContact(true);
                                                        setContact(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                            Coordinator </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Coordinator </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Coordinator </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContact && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contact,
                                          "Coordinator",
                                          "contact5"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>


                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact12 &&
                            transactionId.contact12.length > 0 ? (
                              transactionId.contact12.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {/* <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Other</h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "7",
                                                          "seller_Attorney", "Seller's Attorney"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Attorney </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Attorney </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                          </div> */}
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupSellerOther(
                                                              true
                                                            );
                                                            setContactSellerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupSellerOther(true);
                                                        setContactSellerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>  
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Attorney </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "7",
                                                    "seller_Attorney", "Seller's Attorney"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Attorney </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Attorney </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                              {popupSellerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactSellerOther,
                                          "seller_Other",
                                          "contact12"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>


                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <h4 className="text-light">Buyer's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 buyer float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("2", "buyersale")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addContactseller"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("2", "buyersale")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addContactseller"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact2 &&
                            transactionId.contact2.length > 0 ? (
                              transactionId.contact2.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopup(true);
                                                      setType(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopup(true);
                                                  setType(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>  
                                          {/* <img className="pull-left" src={item?.data?.image || "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"} alt="avatar" /> */}
                                          <span>
                                            <NavLink
                                              // to={`/contact-profile/${item?.data?._id}`}
                                              className="card-title mt-0"
                                            >
                                              <h6 className="mb-1">
                                                {" "}
                                                {item?.data?.firstName}&nbsp;
                                                {item?.data?.lastName}
                                              </h6>
                                            </NavLink>

                                            <p className="mb-1">
                                              {item?.data?.company}
                                            </p>
                                            {item?.data?.phone ? (
                                              <h6 className="mb-0">
                                                <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                {item?.data?.phone}
                                              </h6>
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer</h6>
                                        </div>
                                      </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("2", "buyersale", "Buyer")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addContactseller"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Buyer </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("2", "buyersale", "Buyer")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopup(true);
                                                            setType(item.data._id);
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopup(true);
                                                        setType(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                      </div>


                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "both_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("2", "buyersale", "Buyer")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("2", "buyersale", "Buyer")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addContactseller"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("2", "buyersale", "Buyer")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("2", "buyersale", "Buyer")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addContactseller"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          type,
                                          "buyersale",
                                          "contact2"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => handleCancel(type)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("4", "buy_Agent")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("4", "buy_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer's Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact4 &&
                            transactionId.contact4.length > 0 ? (
                              transactionId.contact4.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupRepresent(true);
                                                      setRepresent(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupRepresent(true);
                                                  setRepresent(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Buyer's Agent</h6>
                                        </div>
                                      </div> 

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                        {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupRepresent(true);
                                                            setRepresent(
                                                              item.data._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupRepresent(true);
                                                        setRepresent(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                      </div>


                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.type === "both_referral" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("4", "buy_Agent", "Buyer's Agent")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupRepresent && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "buy_Agent",
                                          "contact4"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Vendor</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Vendor
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("6", "Vendor")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Vendor
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("6", "Vendor")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Vendor
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact6 &&
                            transactionId.contact6.length > 0 ? (
                              transactionId.contact6.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupValue(true);
                                                  setContactValue(
                                                    item.data._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>
                                          <img
                                            className="pull-left"
                                            src={
                                              item?.data?.image ||
                                              "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                            }
                                            alt="avatar"
                                          />
                                          <span>
                                            <NavLink
                                              // to={`/contact-profile/${item?.data?._id}`}
                                              className="card-title mt-0"
                                            >
                                              <h6 className="mb-1">
                                                {item?.data?.firstName}&nbsp;
                                                {item?.data?.lastName}
                                              </h6>
                                            </NavLink>
                                            <p className="mb-1">
                                              {item?.data?.company}
                                            </p>
                                            {item?.data?.phone ? (
                                              <h6 className="mb-0">
                                                <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                {item?.data?.phone}
                                              </h6>
                                            ) : (
                                              ""
                                            )}
                                          </span>
                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Vendor</h6>
                                          </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>

                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep("6", "Vendor", "Vendor")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Vendor </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("6", "Vendor", "Vendor")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Vendor </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupValue(true);
                                                            setContactValue(
                                                              item.data._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupValue(true);
                                                        setContactValue(
                                                          item.data._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>
                                        </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("6", "Vendor", "Vendor")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Vendor </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("6", "Vendor", "Vendor")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Vendor </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupValue && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactValue,
                                          "Vendor",
                                          "contact6"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact13 &&
                            transactionId.contact13.length > 0 ? (
                              transactionId.contact13.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupBuyerOther(
                                                              true
                                                            );
                                                            setContactBuyerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupBuyerOther(true);
                                                        setContactBuyerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                             ""
                            )}

                              {popupBuyerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactBuyerOther,
                                          "other_buyer",
                                          "contact13"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {transactionId.represent === "referral" ? (
                    <div className="row">
                      <div className="col-md-12">

                        <h4 className="text-light">Seller's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 seller float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add seller
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          className="mt-3"
                                          onClick={() =>
                                            TransactionStep("1", "referralsale")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            seller
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      className="mt-3"
                                      onClick={() =>
                                        TransactionStep("1", "referralsale")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        seller
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact1 &&
                            transactionId.contact1.length > 0 ? (
                              transactionId.contact1.map((item) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={item?.data?._id}
                                >
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setShowPopup(true);
                                                      setRepresent(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setShowPopup(true);
                                                  setRepresent(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                // to={`/contact-profile/${item?.data?._id}`}
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>
                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>
                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>

                                          </div>
                                          <div className="ms-5">
                                              <h6 className="mb-0">Seller</h6>
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>

                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div>
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        className="mt-3"
                                                        onClick={() =>
                                                          TransactionStep("1", "referralsale", "Seller")
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Seller </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                    className="mt-3"
                                                    onClick={() =>
                                                      TransactionStep("1", "referralsale", "Seller")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Seller </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setShowPopup(true);
                                                            setRepresent(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setShowPopup(true);
                                                        setRepresent(item?.data?._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ))
                            ) : (
                              <>
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add seller </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  className="mt-0"
                                                  onClick={() =>
                                                    TransactionStep("1", "referralsale", "Seller")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              className="mt-0"
                                              onClick={() =>
                                                TransactionStep("1", "referralsale", "Seller")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Seller </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div>
                              </>
                            )}

                            {showPopup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "referralsale",
                                          "contact1"
                                        )
                                      }
                                    >
                                      <button
                                        onClick={() => {
                                          setShowModal(true);
                                          setShowPopup(true);
                                        }}
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#conactPopUp"
                                        className="btn btn-primary btn-sm"
                                      >
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  ms-2"
                                      onClick={() => handleCancel(represent)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {showModal && (
                              <div
                                className="modal"
                                role="dialog"
                                id="conactPopUp"
                              >
                                <div className="modal-dialog" role="document">
                                  <div className="modal-content">
                                    <div className="modal-body row">
                                      <div>
                                        <h4>
                                          {" "}
                                          To remove this contact, please add
                                          another client first.
                                        </h4>
                                        <button
                                          type="button"
                                          className="btn btn-default btn btn-primary btn-sm pull-right"
                                          onClick={() => setShowModal(false)}
                                        >
                                          Ok
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              {transactionId.filing === "filed_complted" ? (
                                <div className="">
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Partner
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "3",
                                              "referral_Agent"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Partner
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                    onClick={() =>
                                        TransactionStep("3", "referral_Agent")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Partner
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact3 &&
                            transactionId.contact3.length > 0 ? (
                              transactionId.contact3.map((item, index) => (
                                <div
                                  className="card bg-secondary mt-0"
                                  key={index}
                                >
                                  {item ? (
                                    <>
                                      <div className="card-body">
                                        {/* {transactionId.filing ===
                                        "filed_complted" ? (
                                          <div className="edit_delete_action d-flex align-items-center justify-content-between">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </div>
                                        ) : (
                                          <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                         
                                              <i
                                                onClick={() => {
                                                  setPopupPhase(true);
                                                  setPhase(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                        </div>
                                        )} */}

                                         {/* Ensure item?.data exists before checking type */}
                                         {/* {item?.data ? (
                                          item?.data.type ===
                                          "referral_Agent" ? (
                                            <h6 className="mb-2 text-center">
                                              Referring Agent
                                            </h6>
                                          ) : item?.data.type ===
                                            "receiving_Agent" ? (
                                            <h6 className="mb-2 text-center">
                                              Receiving Agent
                                            </h6>
                                          ) : (
                                            <h6 className="mb-2 text-center">
                                              Referring Agent
                                            </h6>
                                          )
                                        ) : (
                                          <h6 className="mb-2 text-center">
                                            Referring Agent
                                          </h6> 
                                        )} */}


                                        <div
                                          className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                          // onClick={() =>
                                          //   handleTypeContact(
                                          //     item?.data?.contactType,
                                          //     item?.data?._id
                                          //   )
                                          // }
                                        >
                                          <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                            <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                            onClick={() =>
                                              handleTypeContact(
                                                item?.data?.contactType,
                                                item?.data?._id
                                              )
                                            }> 
                                              <img
                                                className="pull-left"
                                                src={
                                                  item?.data?.image ||
                                                  "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                                }
                                                alt="avatar"
                                              />

                                              <span>
                                                <NavLink className="card-title mt-0">
                                                  <h6 className="mb-1">
                                                    {item?.data?.firstName}&nbsp;
                                                    {item?.data?.lastName}
                                                  </h6>
                                                </NavLink>
                                                <p className="mb-1">
                                                  {item?.data?.company}
                                                </p>
                                                {item?.data?.phone && (
                                                  <h6 className="mb-0">
                                                    <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                    {item?.data?.phone}
                                                  </h6>
                                                )}
                                              </span>
                                            </div>
                                            <div className="ms-5">
                                                {item?.data ? (
                                                  item?.data.type ===
                                                  "referral_Agent" ? (
                                                    <h6 className="mb-0">
                                                      Referring Agent
                                                    </h6>
                                                  ) : item?.data.type ===
                                                    "receiving_Agent" ? (
                                                    <h6 className="mb-0">
                                                      Receiving Agent
                                                    </h6>
                                                  ) : (
                                                    <h6 className="mb-0">
                                                      Referring Agent
                                                    </h6>
                                                  )
                                                ) : (
                                                  <h6 className="mb-0">
                                                    Referring Agent
                                                  </h6> 
                                                )}
                                            </div>
                                        </div>
                                          <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          <div className="mb-0 me-5">
                                            {transactionId.filing === "filed_complted" ? (
                                              <div className="">
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  title="Your transaction was completed"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Partner </h6>
                                                </button>
                                              </div>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <div
                                                        onClick={() =>
                                                          TransactionStep(
                                                            "3",
                                                            "referral_Agent", "Partner"
                                                          )
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-link p-0"
                                                          data-toggle="modal"
                                                          data-target="#addcontact"
                                                        >
                                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                          Partner </h6>
                                                        </button>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <div
                                                  onClick={() =>
                                                      TransactionStep("3", "referral_Agent", "Partner")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Partner </h6>
                                                    </button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>

                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex align-items-center justify-content-between">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            
                                                  <i
                                                    onClick={() => {
                                                      setPopupPhase(true);
                                                      setPhase(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                              </span>
                                            )}

                                        </div>

                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              <div className="card bg-secondary mt-0 requiredcontact">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div className="">
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Partner </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep(
                                                        "3",
                                                        "referral_Agent", "Partner"
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Partner </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                              onClick={() =>
                                                  TransactionStep("3", "referral_Agent", "Partner")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Partner </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                    </div>
                                </div>
                              </div>
                              </>
                            )}

                            {popupPhase && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          phase,
                                          "referral_Agent",
                                          "contact3"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">
                                Seller's Agent's Coordinator
                              </h6>
                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add
                                    Coordinator
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("5", "Coordinator")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Coordinator
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("5", "Coordinator")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Coordinator
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact5 &&
                            transactionId.contact5.length > 0 ? (
                              transactionId.contact5.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContact(true);
                                                      setContact(
                                                        item?.data?._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupContact(true);
                                                  setContact(item?.data?._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                        onClick={() =>
                                          handleTypeContact(
                                            item?.data?.contactType,
                                            item?.data?._id
                                          )
                                        }>
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />

                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent's Coordinator</h6>
                                        </div>
                                      </div>
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                        <div className="">
                                        <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                        </div>
                                        <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Coordinator </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Coordinator </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Coordinator </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>

                                        {transactionId.filing ===
                                          "filed_complted" ? (
                                            <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i className="h2 fi-trash opacity-80 pull-left"></i>
                                              <i className="h2 fi-edit opacity-80 pull-right"></i>
                                            </span>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                      <i
                                                        onClick={() => {
                                                          setPopupContact(true);
                                                          setContact(
                                                            item?.data?._id
                                                          );
                                                        }}
                                                        className="h2 fi-trash opacity-80 pull-left"
                                                      ></i>
                                                      <i
                                                        className="h2 fi-edit opacity-80 pull-right"
                                                        onClick={() =>
                                                          TransactionEdit(
                                                            item?.data?.contactType,
                                                            item?.data?._id
                                                          )
                                                        }
                                                      ></i>
                                                    </span>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupContact(true);
                                                      setContact(item?.data?._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </span>
                                              )}
                                            </>
                                          )}

                                      </div>

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                            Coordinator </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Coordinator </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("5", "Coordinator", "Seller's Agent's Coordinator")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Coordinator </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupContact && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contact,
                                          "Coordinator",
                                          "contact5"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact12 &&
                            transactionId.contact12.length > 0 ? (
                              transactionId.contact12.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {/* <div className="mb-0 me-5">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Other</h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "7",
                                                          "seller_Attorney", "Seller's Attorney"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Seller's Attorney </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Seller's Attorney </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                          </div> */}
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupSellerOther(
                                                              true
                                                            );
                                                            setContactSellerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupSellerOther(true);
                                                        setContactSellerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>  
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  <p className="p-0">Not Selected.</p>
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Seller's
                                          Attorney </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "7",
                                                    "seller_Attorney", "Seller's Attorney"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Seller's Attorney </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            onClick={() =>
                                              TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontact"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                              Seller's Attorney </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div> */}
                              </>
                            )}

                              {popupSellerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactSellerOther,
                                          "seller_Other",
                                          "contact12"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">

                        <h4 className="text-light">Buyer's Side</h4>
                        <div className="bg-light border rounded-3 mb-2 p-3 float-start w-100">
                          <div className="content_main mb-4 buyer float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Seller's Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Seller'
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "2",
                                              "referral_sellerAgent"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addContactseller"
                                          >
                                            <i className="fi-plus me-2"></i>
                                            Seller' Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep(
                                          "2",
                                          "referral_sellerAgent"
                                        )
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addContactseller"
                                      >
                                        <i className="fi-plus me-2"></i>Seller'
                                        Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact2 &&
                            transactionId.contact2.length > 0 ? (
                              transactionId.contact2.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopup(true);
                                                      setType(item.data._id);
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopup(true);
                                                  setType(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>  
                                        {/* <img className="pull-left" src={item?.data?.image || "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"} alt="avatar" /> */}
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>

                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                        </div>
                                        <div className="ms-5">
                                            <h6 className="mb-0">Seller's Agent</h6>
                                        </div>
                                    </div> 
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <i className="fi-plus me-2"></i>Seller'
                                              Agent
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep(
                                                        "2",
                                                        "referral_sellerAgent", "Seller' Agent"
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addContactseller"
                                                    >
                                                      <i className="fi-plus me-2"></i>
                                                      Seller' Agent
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "2",
                                                    "referral_sellerAgent", "Seller' Agent"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addContactseller"
                                                >
                                                  <i className="fi-plus me-2"></i>Seller'
                                                  Agent
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopup(true);
                                                        setType(item.data._id);
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopup(true);
                                                    setType(item.data._id);
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div>   

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.referralSend === "no" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <i className="fi-plus me-2"></i>Seller'
                                                Agent
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "2",
                                                          "referral_sellerAgent", "Seller' Agent"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <i className="fi-plus me-2"></i>
                                                        Seller' Agent
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "2",
                                                      "referral_sellerAgent", "Seller' Agent"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addContactseller"
                                                  >
                                                    <i className="fi-plus me-2"></i>Seller'
                                                    Agent
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                title="Your transaction was completed"
                                              >
                                                <i className="fi-plus me-2"></i>Seller'
                                                Agent
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "2",
                                                          "referral_sellerAgent", "Seller' Agent"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addContactseller"
                                                      >
                                                        <i className="fi-plus me-2"></i>
                                                        Seller' Agent
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "2",
                                                      "referral_sellerAgent", "Seller' Agent"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addContactseller"
                                                  >
                                                    <i className="fi-plus me-2"></i>Seller'
                                                    Agent
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popup && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          type,
                                          "referral_sellerAgent",
                                          "contact2"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => handleCancel(type)}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Buyer's Agent</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                  >
                                    <i className="fi-plus me-2"></i>Add buyer's
                                    Agent
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep(
                                              "4",
                                              "referralbuy_Agent"
                                            )
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            buyer's Agent
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep(
                                          "4",
                                          "referralbuy_Agent"
                                        )
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        buyer's Agent
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}

                            {transactionId &&
                            transactionId.contact4 &&
                            transactionId.contact4.length > 0 ? (
                              transactionId.contact4.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupRepresent(true);
                                                      setRepresent(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupRepresent(true);
                                                  setRepresent(item.data._id);
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto0">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                      <div className="ms-5">
                                          <h6 className="mb-0">Buyer's Agent</h6>
                                      </div>
                                    </div>   
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>
                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                              Agent </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep(
                                                        "4",
                                                        "referralbuy_Agent", "Buyer's Agent"
                                                      )
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Buyer's Agent </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep(
                                                    "4",
                                                    "referralbuy_Agent", "Buyer's Agent"
                                                  )
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Buyer's Agent </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>

                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupRepresent(true);
                                                        setRepresent(
                                                          item.data._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupRepresent(true);
                                                    setRepresent(item.data._id);
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div> 

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                                {transactionId.referralSend === "no" ? (
                                  <div className="card bg-secondary mt-0">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "4",
                                                          "referralbuy_Agent", "Buyer's Agent"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "4",
                                                      "referralbuy_Agent", "Buyer's Agent"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="card bg-secondary mt-0 requiredcontact">
                                    <div className="card-body">
                                        <p className="p-0">Not Selected.</p>
                                        <div className="d-flex align-items-center justify-content-center py-0">
                                          {transactionId.filing === "filed_complted" ? (
                                            <div>
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add buyer's
                                                Agent </h6>
                                              </button>
                                            </div>
                                          ) : (
                                            <>
                                              {transactionFundingRequest?.invoice_url ? (
                                                localStorage.getItem("auth") &&
                                                jwt(localStorage.getItem("auth"))
                                                  .contactType == "admin" ? (
                                                  <>
                                                    <div
                                                      onClick={() =>
                                                        TransactionStep(
                                                          "4",
                                                          "referralbuy_Agent", "Buyer's Agent"
                                                        )
                                                      }
                                                    >
                                                      <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        data-toggle="modal"
                                                        data-target="#addcontact"
                                                      >
                                                        <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                        Buyer's Agent </h6>
                                                      </button>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )
                                              ) : (
                                                <div
                                                  onClick={() =>
                                                    TransactionStep(
                                                      "4",
                                                      "referralbuy_Agent", "Buyer's Agent"
                                                    )
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Buyer's Agent </h6>
                                                  </button>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </div>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {popupRepresent && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          represent,
                                          "referralbuy_Agent",
                                          "contact4"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="content_main mb-4 float-start w-100">
                            {/* <div className="d-flex align-items-center justify-content-between border-bottom mb-3 pb-2">
                              <h6 className="mb-0">Vendor</h6>

                              {transactionId.filing === "filed_complted" ? (
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    title="Your transaction was completed"
                                  >
                                    <i className="fi-plus me-2"></i>Add Vendor
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {transactionFundingRequest?.invoice_url ? (
                                    localStorage.getItem("auth") &&
                                    jwt(localStorage.getItem("auth"))
                                      .contactType == "admin" ? (
                                      <>
                                        <div
                                          onClick={() =>
                                            TransactionStep("6", "Vendor")
                                          }
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            data-toggle="modal"
                                            data-target="#addcontact"
                                          >
                                            <i className="fi-plus me-2"></i>Add
                                            Vendor
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )
                                  ) : (
                                    <div
                                      onClick={() =>
                                        TransactionStep("6", "Vendor")
                                      }
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        data-toggle="modal"
                                        data-target="#addcontact"
                                      >
                                        <i className="fi-plus me-2"></i>Add
                                        Vendor
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </div> */}
                            {transactionId &&
                            transactionId.contact6 &&
                            transactionId.contact6.length > 0 ? (
                              transactionId.contact6.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      {/* {transactionId.filing ===
                                      "filed_complted" ? (
                                        <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                          <i className="h2 fi-trash opacity-80 pull-left"></i>
                                          <i className="h2 fi-edit opacity-80 pull-right"></i>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                  <i
                                                    onClick={() => {
                                                      setPopupValue(true);
                                                      setContactValue(
                                                        item.data._id
                                                      );
                                                    }}
                                                    className="h2 fi-trash opacity-80 pull-left"
                                                  ></i>
                                                  <i
                                                    className="h2 fi-edit opacity-80 pull-right"
                                                    onClick={() =>
                                                      TransactionEdit(
                                                        item?.data?.contactType,
                                                        item?.data?._id
                                                      )
                                                    }
                                                  ></i>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div className="edit_delete_action d-flex alin-items-center justify-content-end">
                                              <i
                                                onClick={() => {
                                                  setPopupValue(true);
                                                  setContactValue(
                                                    item.data._id
                                                  );
                                                }}
                                                className="h2 fi-trash opacity-80 pull-left"
                                              ></i>
                                              <i
                                                className="h2 fi-edit opacity-80 pull-right"
                                                onClick={() =>
                                                  TransactionEdit(
                                                    item?.data?.contactType,
                                                    item?.data?._id
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          )}
                                        </>
                                      )} */}

                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                        // onClick={() =>
                                        //   handleTypeContact(
                                        //     item?.data?.contactType,
                                        //     item?.data?._id
                                        //   )
                                        // }
                                      >

                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                      onClick={() =>
                                        handleTypeContact(
                                          item?.data?.contactType,
                                          item?.data?._id
                                        )
                                      }>  
                                        <img
                                          className="pull-left"
                                          src={
                                            item?.data?.image ||
                                            "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                          }
                                          alt="avatar"
                                        />
                                        <span>
                                          <NavLink
                                            // to={`/contact-profile/${item?.data?._id}`}
                                            className="card-title mt-0"
                                          >
                                            <h6 className="mb-1">
                                              {item?.data?.firstName}&nbsp;
                                              {item?.data?.lastName}
                                            </h6>
                                          </NavLink>
                                          <p className="mb-1">
                                            {item?.data?.company}
                                          </p>
                                          {item?.data?.phone ? (
                                            <h6 className="mb-0">
                                              <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                              {item?.data?.phone}
                                            </h6>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                      <div className="ms-5">
                                          <h6 className="mb-0">Vendor</h6>
                                      </div>
                                    </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                      <div className="">
                                      <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                      </div>

                                      <div className="mb-0 me-5">
                                        {transactionId.filing === "filed_complted" ? (
                                          <div>
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              title="Your transaction was completed"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                            </button>
                                          </div>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <div
                                                    onClick={() =>
                                                      TransactionStep("6", "Vendor", "Vendor")
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-link p-0"
                                                      data-toggle="modal"
                                                      data-target="#addcontact"
                                                    >
                                                      <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                      Vendor </h6>
                                                    </button>
                                                  </div>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <div
                                                onClick={() =>
                                                  TransactionStep("6", "Vendor", "Vendor")
                                                }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontact"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                  Vendor </h6>
                                                </button>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {transactionId.filing ===
                                        "filed_complted" ? (
                                          <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                            <i className="h2 fi-trash opacity-80 pull-left"></i>
                                            <i className="h2 fi-edit opacity-80 pull-right"></i>
                                          </span>
                                        ) : (
                                          <>
                                            {transactionFundingRequest?.invoice_url ? (
                                              localStorage.getItem("auth") &&
                                              jwt(localStorage.getItem("auth"))
                                                .contactType == "admin" ? (
                                                <>
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupValue(true);
                                                        setContactValue(
                                                          item.data._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                </>
                                              ) : (
                                                <></>
                                              )
                                            ) : (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i
                                                  onClick={() => {
                                                    setPopupValue(true);
                                                    setContactValue(
                                                      item.data._id
                                                    );
                                                  }}
                                                  className="h2 fi-trash opacity-80 pull-left"
                                                ></i>
                                                <i
                                                  className="h2 fi-edit opacity-80 pull-right"
                                                  onClick={() =>
                                                    TransactionEdit(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                ></i>
                                              </span>
                                            )}
                                          </>
                                        )}

                                    </div>  

                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                              <>
                              {/* <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                    <p className="p-0">Not Selected.</p>
                                    <div className="d-flex align-items-center justify-content-center py-0">
                                      {transactionId.filing === "filed_complted" ? (
                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-link p-0"
                                            title="Your transaction was completed"
                                          >
                                            <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add Vendor </h6>
                                          </button>
                                        </div>
                                      ) : (
                                        <>
                                          {transactionFundingRequest?.invoice_url ? (
                                            localStorage.getItem("auth") &&
                                            jwt(localStorage.getItem("auth"))
                                              .contactType == "admin" ? (
                                              <>
                                                <div
                                                  onClick={() =>
                                                    TransactionStep("6", "Vendor", "Vendor")
                                                  }
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    data-toggle="modal"
                                                    data-target="#addcontact"
                                                  >
                                                    <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                    Vendor </h6>
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )
                                          ) : (
                                            <div
                                              onClick={() =>
                                                TransactionStep("6", "Vendor", "Vendor")
                                              }
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-link p-0"
                                                data-toggle="modal"
                                                data-target="#addcontact"
                                              >
                                                <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Add
                                                Vendor </h6>
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                </div>
                              </div> */}
                              </>
                            )}

                            {popupValue && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactValue,
                                          "Vendor",
                                          "contact6"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm  mt-3"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>


                          <div className="content_main mb-4 float-start w-100">
                            {transactionId &&
                            transactionId.contact13 &&
                            transactionId.contact13.length > 0 ? (
                              transactionId.contact13.map((item) => (
                                <div className="card bg-secondary mt-0">
                                  {item ? (
                                    <div className="card-body">
                                      <div
                                        className="view_profile float-start w-100 d-flex align-items-center justify-content-between"
                                      >
                                        <div className="d-flex align-items-center justify-content-start col-lg-9 col-md-9 col-auto">
                                          <div className="d-flex align-items-center justify-content-start col-lg-3 col-md-3 col-auto"
                                          onClick={() =>
                                            handleTypeContact(
                                              item?.data?.contactType,
                                              item?.data?._id
                                            )
                                          }>  
                                            <img
                                              className="pull-left"
                                              src={
                                                item?.data?.image ||
                                                "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                              }
                                              alt="avatar"
                                            />

                                            <span>
                                              <NavLink
                                                className="card-title mt-0"
                                              >
                                                <h6 className="mb-1">
                                                  {item?.data?.firstName}&nbsp;
                                                  {item?.data?.lastName}
                                                </h6>
                                              </NavLink>

                                              <p className="mb-1">
                                                {item?.data?.company}
                                              </p>

                                              {item?.data?.phone ? (
                                                <h6 className="mb-0">
                                                  <i className="h2 fi-phone opacity-80 me-2 mb-0"></i>
                                                  {item?.data?.phone}
                                                </h6>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            </div>
                                            <div className="ms-5">
                                                <h6 className="mb-0">{item?.data?.name_other}</h6>
                                            </div>
                                        </div>  
                                        <div className="d-flex align-items-center justify-content-between me-0 col-lg-3 col-md-3 col-auto">
                                          <div className="">
                                          <h6 className="mb-0 me-5">
                                        <div className="dropdown">
                                          <button
                                            className="border-0 dropdown-toggle bg-transparent pe-0"
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                          <b>Actions</b>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                              <li>
                                                <a
                                                data-toggle="modal"
                                                data-target="#invitecontact"
                                                  onClick={() =>
                                                    sendinvitationContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                  className="dropdown-item"
                                                >
                                                  <i className="fa fa-envelope"></i>{" "}
                                                  Send Invitation to Collaborate
                                                </a>
                                              </li>
                                              <li>
                                                <a
                                                  className="dropdown-item"
                                                  onClick={() =>
                                                    handleTypeContact(
                                                      item?.data?.contactType,
                                                      item?.data?._id
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-external-link"></i>{" "}
                                                  Go to client Profile
                                                </a>
                                              </li>
                                          </ul>
                                        </div>
                                      </h6>
                                          </div>
                                          {transactionId.filing ===
                                            "filed_complted" ? (
                                              <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                <i className="h2 fi-trash opacity-80 pull-left"></i>
                                                <i className="h2 fi-edit opacity-80 pull-right"></i>
                                              </span>
                                            ) : (
                                              <>
                                                {transactionFundingRequest?.invoice_url ? (
                                                  localStorage.getItem("auth") &&
                                                  jwt(localStorage.getItem("auth"))
                                                    .contactType == "admin" ? (
                                                    <>
                                                      <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                        <i
                                                          onClick={() => {
                                                            setPopupBuyerOther(
                                                              true
                                                            );
                                                            setContactBuyerOther(
                                                              item?.data?._id
                                                            );
                                                          }}
                                                          className="h2 fi-trash opacity-80 pull-left"
                                                        ></i>
                                                        <i
                                                          className="h2 fi-edit opacity-80 pull-right"
                                                          onClick={() =>
                                                            TransactionEdit(
                                                              item?.data?.contactType,
                                                              item?.data?._id
                                                            )
                                                          }
                                                        ></i>
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )
                                                ) : (
                                                  <span className="edit_delete_action d-flex alin-items-center justify-content-end">
                                                    <i
                                                      onClick={() => {
                                                        setPopupBuyerOther(true);
                                                        setContactBuyerOther(
                                                          item?.data?._id
                                                        );
                                                      }}
                                                      className="h2 fi-trash opacity-80 pull-left"
                                                    ></i>
                                                    <i
                                                      className="h2 fi-edit opacity-80 pull-right"
                                                      onClick={() =>
                                                        TransactionEdit(
                                                          item?.data?.contactType,
                                                          item?.data?._id
                                                        )
                                                      }
                                                    ></i>
                                                  </span>
                                                )}
                                              </>
                                            )}

                                        </div>

                                      </div>

                                  
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))
                            ) : (
                             ""
                            )}

                              {popupBuyerOther && (
                              <div className="ContactCardConfirm">
                                <div className="ConfirmContent">
                                  <label className="col-col-form-label pt-0">
                                    Remove this contact?
                                  </label>
                                  <div className="pull-right mt-4">
                                    <a
                                      onClick={() =>
                                        handleDelete(
                                          contactBuyerOther,
                                          "other_buyer",
                                          "contact13"
                                        )
                                      }
                                    >
                                      <button className="btn btn-primary btn-sm">
                                        Yes
                                      </button>
                                    </a>

                                    <button
                                      className="btn btn-secondary btn-sm ms-2"
                                      onClick={handleCancel}
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                             )}
                          </div>

                          {/* default add contact button section */}
                          <div className="content_main mb-4 float-start w-100">
                              <div className="card bg-secondary mt-0">
                                <div className="card-body">
                                  {/* <p className="p-0">Not Selected.</p> */}
                                  <div className="d-flex align-items-center justify-content-center py-0">
                                    {transactionId.filing === "filed_complted" ? (
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-link p-0"
                                          title="Your transaction was completed"
                                        >
                                          <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        {transactionFundingRequest?.invoice_url ? (
                                          localStorage.getItem("auth") &&
                                          jwt(localStorage.getItem("auth"))
                                            .contactType == "admin" ? (
                                            <>
                                              <div
                                                // onClick={() =>
                                                //   TransactionStep(
                                                //     "7",
                                                //     "seller_Attorney", "Seller's Attorney"
                                                //   )
                                                // }
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-link p-0"
                                                  data-toggle="modal"
                                                  data-target="#addcontactparty"
                                                >
                                                  <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )
                                        ) : (
                                          <div
                                            // onClick={() =>
                                            //   TransactionStep("7", "seller_Attorney", "Seller's Attorney")
                                            // }
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-link p-0"
                                              data-toggle="modal"
                                              data-target="#addcontactparty"
                                            >
                                              <h6 className="p-0 m-0"><i className="fi-plus me-2"></i>Party to Transaction </h6>
                                            </button>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <form className="new_transaction d-none">
            <input
              type="text"
              name="represent"
              id="represent"
              value={step1.represent}
            />
            <br />
            <input type="text" name="type" id="type" value={step2.type} />
            <br />
            <input type="text" name="phase" id="phase" value={step3.phase} />
            <br />
            <input
              type="text"
              name="represent"
              id="represent"
              value={step4.represent}
            />
            <br />
            <input
              type="text"
              name="contact"
              id="contactid"
              value={step5.contact}
            />
            <br />
            <input
              type="text"
              name="contactValue"
              id="contactid"
              value={step6.contactValue}
            />
            <br />
            <input
              type="text"
              name="contactNew"
              id="contactid"
              value={step7.contactNew}
            />

            <br />
            <input
              type="text"
              name="contactVendor"
              id="contactid"
              value={step8.contactVendor}
            />

            <br />
            <input
              type="text"
              name="contactPartner"
              id="contactid"
              value={step9.contactPartner}
            />

            <br />
            <input
              type="text"
              name="contactHome"
              id="contactid"
              value={step10.contactHome}
            />

            <br />
            <input
              type="text"
              name="contactLender"
              id="contactid"
              value={step11.contactLender}
            />
              <br />
            <input
              type="text"
              name="contactSellerOther"
              id="contactid"
              value={step12.contactSellerOther}
            />
              <br />
            <input
              type="text"
              name="contactBuyerOther"
              id="contactid"
              value={step13.contactBuyerOther}
            />
          </form>
        </div>

        <div className="modal" tabindex="-1" role="dialog" id="addcontact">
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Contact</h4>
                <button
                  className="btn-close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body fs-sm">
                <div className="row">
                  {addUserConfirmation ? (
                    <div className="col-md-6 mt-0 w-100">
                      <div className="card bg-secondary mt-0">
                        <div className="card-body">
                          <img
                            className="remove_icon pull-right"
                            src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                          />
                          <div className="view_profile">
                            <img
                              className="pull-left"
                              src="https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                              alt="avtar"
                            />
                            <span>
                              <a href="#" className="card-title mt-0">
                                {select.firstName}&nbsp;{select.lastName}
                              </a>
                              <p>
                                {select.company}
                                <br />
                                {select.phone}
                                <br />
                                <a href="#">Send Message</a>
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-default btn btn-secondary btn-sm"
                        id="closeModal"
                        data-dismiss="modal"
                      >
                        Cancel & Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm  pull-left mt-2"
                        onClick={selectContact}
                      >
                        Select Contact
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="col-md-12">
                        <form className="form-group shadow-none border-0 rounded-0 border-bottom mb-2">
                          <div className="input-group input-group-sm p-0">
                            <span className="input-group-text text-muted p-0">
                              <i className="fi-search"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search a Contact..."
                              name="firstName"
                              value={formValues.firstName}
                              onChange={handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className=" col-md-6 mt-2">
                        {select === "" ? (
                          <>
                          <div className="rounded-3 border p-3">
                            <form onSubmit={handleSearch}>
                              {/* <!-- First Name input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">First Name</label>
                                <br />
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="firstName"
                                  placeholder="Enter your first name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.firstName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.firstName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.firstName}
                                </div>
                              </div>

                              {/* <!-- Last Name input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Last Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="lastName"
                                  placeholder="Enter your last name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.lastName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.lastName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.lastName}
                                </div>
                              </div>

                              {/* <!-- Company Input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Company</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="company"
                                  placeholder="Enter your company"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  value={formValues.company}
                                />
                              </div>

                              {/* <!-- Email input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Email</label>
                                <input
                                  className="form-control"
                                  id="email-input"
                                  type="text"
                                  name="email"
                                  placeholder="Enter your email"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.email
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.email}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.email}
                                </div>
                              </div>

                              {/* <!-- Phone Input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Phone</label>
                                <input
                                  className="form-control"
                                  type="tel"
                                  id="tel-input"
                                  name="phone"
                                  placeholder="Enter your Phone"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  pattern="[0-9]+"
                                  required
                                  title="Please enter a valid phone number"
                                  value={formValues.phone}
                                />
                              </div>

                              {/* <!-- Checkbox Input --> */}
                              <div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="checkbox"
                                    type="checkbox"
                                    id="agree-to-terms"
                                    onClick={handleCheck}
                                    value={checkBox.checkBox}
                                  />
                                  <div className="invalid-tooltip">
                                    {checkBox.checkBox}
                                  </div>
                                  <label className="form-check-label">
                                    No email address available.
                                  </label>
                                </div>
                              </div>


                                  {/* <!-- Checkbox Input for side --> */} 
                              {/* <div>
                                <label className="col-col-form-label">Party to Transaction Sides </label>
                                <br />
                                <small>Please check one of the side , in which side you want to add the contact either it buyer side or Sellet side.</small>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="buyer-side"
                                    checked={selectedSide === 'buyer'}
                                    onChange={() => handleCheckside('buyer')}
                                  />
                                  <label className="form-check-label" htmlFor="buyer-side">
                                    Buyer Side
                                  </label>
                                </div>

                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="seller-side"
                                    checked={selectedSide === 'seller'}
                                    onChange={() => handleCheckside('seller')}
                                  />
                                  <label className="form-check-label" htmlFor="seller-side">
                                    Seller Side
                                  </label>
                                </div>
                              </div> */}

                              {/* <!-- Title input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Title</label>
                                  <input
                                  className="form-control"
                                  id="email-input"
                                  type="text"
                                  // name="title"
                                  placeholder=""
                                  // onChange={(event) => handleChange(event)}
                                  // autoComplete="on"
                                  // style={{
                                  //   border: formErrors?.email
                                  //     ? "1px solid red"
                                  //     : "1px solid #00000026",
                                  // }}
                                  value= {contactTitle}
                                  readOnly
                                />

                              </div>

                            </form>
                          </div>
                          <div className="modal-footer border-0 p-0 mt-3 d-block">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              id="save-button"
                              onClick={handleNewContact}
                            >
                              Add Contact
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm ms-3"
                              id="closeModal"
                              data-dismiss="modal"
                            >
                              Cancel & Close
                            </button>
                          </div>
                          </>
                        ) : (
                          <div className="col-md-6 mt-0 w-100">
                            <div className="card bg-secondary mt-0">
                              <div className="card-body">
                                <img
                                  className="remove_icon pull-right"
                                  src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                                />
                                <div className="view_profile">
                                  <img
                                    className="rounded-circle pull-left"
                                    src={
                                      select.image ||
                                      "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                    }
                                    alt="avtar"
                                  />
                                  <span>
                                    <strong>
                                      <NavLink className="list-group-item mt-0">
                                        {select.firstName}&nbsp;
                                        {select.lastName}
                                      </NavLink>
                                    </strong>
                                    <p className="mb-0">
                                      {select.company}
                                      <br />
                                      {select.phone}
                                      <br />
                                      <NavLink>Send Message</NavLink>
                                    </p>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="pull-right mt-3">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm  pull-left"
                                onClick={selectContact}
                              >
                                Select Contact
                              </button>
                              <button
                                type="button"
                                className="btn btn-default btn btn-secondary btn-sm ms-3"
                                id="closeModal"
                                data-dismiss="modal"
                                onClick={Cancel}
                              >
                                Cancel & Close
                              </button>
                            </div>
                          </div>
                        )}
                        
                      </div>
                      <div className=" col-md-6 mt-2">
                        {isLoading ? (
                          ""
                        ) : (
                          <div className="">
                            {results && results.length > 0
                              ? results.map((post) => (
                                  <ul
                                    className="list-group"
                                    onClick={(e) =>
                                      handleSearchTransaction(post._id)
                                    }
                                  >
                                    <li className="list-group-item d-flex justify-content-start align-items-center mt-0">
                                      <img
                                        className="rounded-circle avtar"
                                        src={post.image || avtar}
                                        alt="Profile"
                                      />

                                      <span className="float-left text-left w-100 ms-2">
                                        {/* <img className="avtar" src={avtar} /> */}{" "}
                                        <strong>
                                          {post.firstName}
                                          {post.lastName}
                                        </strong>
                                        <br />
                                        {post.company}
                                        <br />
                                        {post.phone}
                                      </span>
                                    </li>
                                  </ul>
                                ))
                              : ""}
                          </div>
                        )}
                      </div>
                      {results && results.length > 0 ?  
                      <div className="pagination justify-content-end mb-0 mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center mb-0 mt-3"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                      :""
                      }
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal" role="dialog" id="addContactseller">
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Contact</h4>
                <button
                  className="btn-close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body fs-sm">
                <div className="row">
                  {addUserConfirmation ? (
                    <div className="col-md-6 mt-0 w-100">
                      <div className="card bg-secondary mt-0">
                        <div className="card-body">
                          <img
                            className="remove_icon pull-right"
                            src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                          />
                          <div className="view_profile">
                            <img
                              className="pull-left"
                              src="https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                              alt="avtar"
                            />
                            <span>
                              <a href="#" className="card-title mt-0">
                                {select.firstName}&nbsp;{select.lastName}
                              </a>
                              <p>
                                {select.company}
                                <br />
                                {select.phone}
                                <br />
                                <a href="#">Send Message</a>
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-default btn btn-secondary btn-sm"
                        id="closeModalnew"
                        data-dismiss="modal"
                      >
                        Cancel & Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm  pull-left mt-2"
                        onClick={selectContactss}
                      >
                        Select Contact
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="col-md-12">
                        <form className="form-group shadow-none border-0 rounded-0 border-bottom mb-2">
                          <div className="input-group input-group-sm p-0">
                            <span className="input-group-text text-muted p-0">
                              <i className="fi-search"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search a Contact..."
                              name="firstName"
                              value={formValues.firstName}
                              onChange={handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className=" col-md-6 mt-2">
                        {select === "" ? (
                          <>
                          <div className="rounded-3 border p-3">
                            <form onSubmit={handleSearch}>
                              {/* <!-- First Name input --> */}
                              <div className="mb-2">
                                <label className="col-form-label">First Name</label>
                                <br />
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="firstName"
                                  placeholder="Enter your first name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.firstName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.firstName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.firstName}
                                </div>
                              </div>

                              {/* <!-- Last Name input --> */}
                              <div className="mb-2">
                                <label className="col-form-label">Last Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="lastName"
                                  placeholder="Enter your last name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.lastName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.lastName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.lastName}
                                </div>
                              </div>

                              {/* <!-- Company Input --> */}
                              <div className="mb-2">
                                <label className="col-form-label">Company</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="company"
                                  placeholder="Enter your company"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  value={formValues.company}
                                />
                              </div>

                              {/* <!-- Email input --> */}
                              <div className="mb-2">
                                <label className="col-form-label">Email</label>
                                <input
                                  className="form-control"
                                  id="email-input"
                                  type="text"
                                  name="email"
                                  placeholder="Enter your email"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  // style={{
                                  //     border: formErrors?.email ? '1px solid red' : '1px solid #00000026'
                                  // }}
                                  value={formValues.email}
                                />
                                {/* <div className="invalid-tooltip">{formErrors.email}</div> */}
                              </div>

                              {/* <!-- Phone Input --> */}
                              <div className="mb-2">
                                <label className="col-form-label">Phone</label>
                                <input
                                  className="form-control"
                                  type="tel"
                                  id="tel-input"
                                  name="phone"
                                  placeholder="Enter your Phone"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  pattern="[0-9]+"
                                  required
                                  title="Please enter a valid phone number"
                                  value={formValues.phone}
                                />
                              </div>

                              {/* <!-- Checkbox Input --> */}
                              <div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="checkbox"
                                    type="checkbox"
                                    id="agree-to-terms"
                                    onClick={handleCheck}
                                    value={checkBox.checkBox}
                                  />
                                  <div className="invalid-tooltip">
                                    {checkBox.checkBox}
                                  </div>
                                  <label className="form-check-label">
                                    No email address available.
                                  </label>
                                </div>
                              </div>

                              {/* <!-- Title input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Title</label>
                                <input
                                  className="form-control"
                                  id="email-input"
                                  type="text"
                                  // name="title"
                                  placeholder=""
                                  // onChange={(event) => handleChange(event)}
                                  // autoComplete="on"
                                  // style={{
                                  //   border: formErrors?.email
                                  //     ? "1px solid red"
                                  //     : "1px solid #00000026",
                                  // }}
                                  value= {contactTitle}
                                  readOnly
                                />
                              </div>

                            </form>
                          </div>
                          <div className="modal-footer border-0 p-0 mt-3">
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            id="save-button"
                            onClick={handleContactRightPopup}
                          >
                            Add Contact
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm ms-3"
                            id="closeModalnew"
                            data-dismiss="modal"
                          >
                            Cancel & Close
                          </button>
                        </div>
                          </>
                        ) : (
                          <div className="col-md-6 mt-0 w-100">
                            <div className="card bg-secondary mt-0">
                              <div className="card-body">
                                <img
                                  className="remove_icon pull-right"
                                  src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                                />
                                <div className="view_profile">
                                  <img
                                    className="pull-left"
                                    src={
                                      select.image ||
                                      "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                    }
                                    alt="avtar"
                                  />
                                  <span>
                                    <strong>
                                      <NavLink className="list-group-item mt-0">
                                        {select.firstName}&nbsp;
                                        {select.lastName}
                                      </NavLink>
                                    </strong>
                                    <p>
                                      {select.company}
                                      <br />
                                      {select.phone}
                                      <br />
                                      <NavLink>Send Message</NavLink>
                                    </p>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="pull-right mt-3">
                              <button
                                type="button"
                                className="btn btn-primary btn-sm  pull-left"
                                onClick={selectContactss}
                              >
                                Select Contact
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm ms-3"
                                id="closeModalnew"
                                data-dismiss="modal"
                                onClick={Cancel}
                              >
                                Cancel & Close
                              </button>
                            </div>
                          </div>
                        )}
                        
                      </div>

                      <div className=" col-md-6 mt-2">
                        {isLoading ? (
                          ""
                        ) : (
                          <div className="">
                            {results && results.length > 0
                              ? results.map((post) => (
                                  <div>
                                    <ul
                                      className="list-group"
                                      onClick={(e) =>
                                        handleSearchTransaction(post._id)
                                      }
                                    >
                                      <li className="list-group-item d-flex justify-content-start align-items-center mt-0">
                                        <img
                                          className="avtar"
                                          src={post.image || avtar}
                                          alt="Profile"
                                        />
                                        {/* <img className="avtar" src={avtar} /> */}
                                        <span className="float-left text-left w-100 ms-2">
                                          {" "}
                                          <strong>
                                            {post.firstName}
                                            {post.lastName}
                                          </strong>
                                          <br />
                                          {post.company}
                                          <br />
                                          {post.phone}
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                ))
                              : ""}
                          </div>
                        )}
                      </div>

                      {results && results.length > 0 ?
                      <div className="pagination justify-content-center mb-0 mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center mb-0 mt-3"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                      :""
                      }
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal" tabindex="-1" role="dialog" id="addcontactparty">
          <div
            className="modal-dialog modal-lg modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Contact</h4>
                <button
                  className="btn-close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="closeModalp" 
                ></button>
              </div>
              <div className="modal-body fs-sm">
                <div className="row">
                  {addUserConfirmation ? (
                    <div className="col-md-6 mt-0 w-100">
                      <div className="card bg-secondary mt-0">
                        <div className="card-body">
                          <img
                            className="remove_icon pull-right"
                            src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                          />
                          <div className="view_profile">
                            <img
                              className="pull-left"
                              src="https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                              alt="avtar"
                            />
                            <span>
                              <a href="#" className="card-title mt-0">
                                {select.firstName}&nbsp;{select.lastName}
                              </a>
                              <p>
                                {select.company}
                                <br />
                                {select.phone}
                                <br />
                                <a href="#">Send Message</a>
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-default btn btn-secondary btn-sm"
                        id="closeModalp" 
                        data-dismiss="modal"
                      >
                        Cancel & Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm  pull-left mt-2"
                        onClick={selectContact}
                      >
                        Select Contact
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="col-md-12">
                        <form className="form-group shadow-none border-0 rounded-0 border-bottom mb-2">
                          <div className="input-group input-group-sm p-0">
                            <span className="input-group-text text-muted p-0">
                              <i className="fi-search"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search a Contact..."
                              name="firstName"
                              value={formValues.firstName}
                              onChange={handleChange}
                            />
                          </div>
                        </form>
                      </div>
                      <div className=" col-md-6 mt-2">
                        {select === "" ? (
                          <>
                          <div className="rounded-3 border p-3">
                            <form onSubmit={handleSearch}>
                              {/* <!-- First Name input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">First Name</label>
                                <br />
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="firstName"
                                  placeholder="Enter your first name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.firstName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.firstName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.firstName}
                                </div>
                              </div>

                              {/* <!-- Last Name input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Last Name</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="lastName"
                                  placeholder="Enter your last name"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.lastName
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.lastName}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.lastName}
                                </div>
                              </div>

                              {/* <!-- Company Input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Company</label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="text-input"
                                  name="company"
                                  placeholder="Enter your company"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  value={formValues.company}
                                />
                              </div>

                              {/* <!-- Email input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Email</label>
                                <input
                                  className="form-control"
                                  id="email-input"
                                  type="text"
                                  name="email"
                                  placeholder="Enter your email"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  style={{
                                    border: formErrors?.email
                                      ? "1px solid red"
                                      : "1px solid #00000026",
                                  }}
                                  value={formValues.email}
                                />
                                <div className="invalid-tooltip">
                                  {formErrors.email}
                                </div>
                              </div>

                              {/* <!-- Phone Input --> */}
                              <div className="mb-3">
                                  <label className="col-form-label">Phone</label>
                                <input
                                  className="form-control"
                                  type="tel"
                                  id="tel-input"
                                  name="phone"
                                  placeholder="Enter your Phone"
                                  onChange={(event) => handleChange(event)}
                                  autoComplete="on"
                                  pattern="[0-9]+"
                                  required
                                  title="Please enter a valid phone number"
                                  value={formValues.phone}
                                />
                              </div>

                              {/* <!-- Checkbox Input --> */}
                              <div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="checkbox"
                                    type="checkbox"
                                    id="agree-to-terms"
                                    onClick={handleCheck}
                                    value={checkBox.checkBox}
                                  />
                                  <div className="invalid-tooltip">
                                    {checkBox.checkBox}
                                  </div>
                                  <label className="form-check-label">
                                    No email address available.
                                  </label>
                                </div>
                              </div>
                              
                              <div>
                                <label className="col-form-label">Party to Transaction Sides</label>
                                <br />
                                <small>Please check one of the side , in which side you want to add the contact either it Buyer side or Seller
                                   side.</small>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="buyer-side"
                                    checked={selectedSide === 'buyer'}
                                    onChange={() => handleCheckside('buyer')}
                                  />
                                  <label className="form-check-label" htmlFor="buyer-side">
                                    Buyer Side
                                  </label>
                                </div>

                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="seller-side"
                                    checked={selectedSide === 'seller'}
                                    onChange={() => handleCheckside('seller')}
                                  />
                                  <label className="form-check-label" htmlFor="seller-side">
                                    Seller Side
                                  </label>
                                </div>
                              </div>
                             

                              <div className="mb-3">
                               <label className="col-form-label">Title</label>
                                <select
                                  className="form-select"
                                  id="pr-city"
                                  name="category"
                                  onChange={(event) => {
                                    const selectedValue = event.target.value.split("::");
                                    const [stepNo, value, title] = selectedValue;
                                    TransactionStep(stepNo, value, title);
                                  }}
                                  // value={formValues.contactTitle}
                                  style={{
                                    border: formErrors?.contactTitle ? "1px solid red" : "",
                                  }}
                                >
                                  {selectedSide && selectedSide !== "" ? (
                                    <>
                                      <option value="">Please select the Party to the transaction</option>
                                      {transactionOptions[transactionId.represent]?.[`${selectedSide}Side`]?.map(
                                        ([stepNo, value, title]) => (
                                        
                                          <option key={value} value={`${stepNo}::${value}::${title}`}>
                                            {title}
                                          </option>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <option value="">Please select the Side First</option>
                                  )}
                                </select>
                              </div>

                               

                              {
                                  contactSellerOther==="seller_other" ?
                                  <div className="mb-3">
                                  <label className="form-label">
                                    Add Other Type
                                  </label>
                                  <input
                                  className="form-control"
                                  id="inline-form-input"
                                  type="text"
                                  value={otherSideValue}
                                  onChange={handleInputChange}
                                />  
                                </div>
                                :""                             
                                }

                                 {
                                  contactBuyerOther==="other_buyer" ?
                                  <div className="mb-3">
                                   <label className="form-label">
                                    Add Other Type
                                   </label>
                                  <input
                                  className="form-control"
                                  id="inline-form-input"
                                  type="text"
                                  value={otherSideBuyer}
                                  onChange={handleInputBuyer}
                                /> 
                                </div> 
                                :""                             
                                }

                            </form>
                          </div>
                          <div className="modal-footer border-0 p-0 mt-3 d-block">
                          {
                            contactTitle ?
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            id="save-button"
                            onClick={handleNewContact}
                          >
                            Add Contact
                          </button>
                          :"Please select the Side and Party to the transaction."
                          }
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm ms-3"
                            id="closeModalp"
                            data-dismiss="modal"
                          >
                            Cancel & Close
                          </button>
                          </div>
                          </>
                        ) : (
                          <div className="col-md-6 mt-0 w-100">
                            <div className="card bg-secondary mt-0">
                              <div className="card-body">
                                <img
                                  className="remove_icon pull-right"
                                  src="https://cdn.pboffice.net/shared/transaction/page_select_drop.png"
                                />
                                <div className="view_profile">
                                  <img
                                    className="rounded-circle pull-left"
                                    src={
                                      select.image ||
                                      "https://integra.backagent.net/common/handler/pub/photo.ashx?V=1703c0890a0462fd68520b884a04f86f.0&C=people&S=2&P=%2f!Default%2fThumb%2fphoto_pending.jpg"
                                    }
                                    alt="avtar"
                                  />
                                  <span>
                                    <strong>
                                      <NavLink className="list-group-item mt-0">
                                        {select.firstName}&nbsp;
                                        {select.lastName}
                                      </NavLink>
                                    </strong>
                                    <p className="mb-0">
                                      {select.company}
                                      <br />
                                      {select.phone}
                                      <br />
                                      <NavLink>Send Message</NavLink>
                                    </p>
                                  </span>
                                </div>
                              </div>
                            </div>
                                {/* <!-- Checkbox Input for side --> */} 
                              <div>
                                <label className="col-form-label">Party to Transaction Sides</label>
                                <br />
                                <small>Please check one of the side , in which side you want to add the contact either it Buyer side or Seller
                                   side.</small>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="buyer-side"
                                    checked={selectedSide === 'buyer'}
                                    onChange={() => handleCheckside('buyer')}
                                  />
                                  <label className="form-check-label" htmlFor="buyer-side">
                                    Buyer Side
                                  </label>
                                </div>

                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    name="transaction-side"
                                    type="checkbox"
                                    id="seller-side"
                                    checked={selectedSide === 'seller'}
                                    onChange={() => handleCheckside('seller')}
                                  />
                                  <label className="form-check-label" htmlFor="seller-side">
                                    Seller Side
                                  </label>
                                </div>
                              </div>
                                

                                <div className="mb-3">
                               <label className="col-form-label">Title</label>
                                <select
                                  className="form-select"
                                  id="pr-city"
                                  name="category"
                                  onChange={(event) => {
                                    const selectedValue = event.target.value.split("::");
                                    const [stepNo, value, title] = selectedValue;
                                    TransactionStep(stepNo, value, title);
                                  }}
                                  // value={formValues.contactTitle}
                                  style={{
                                    border: formErrors?.contactTitle ? "1px solid red" : "",
                                  }}
                                >
                                  {selectedSide && selectedSide !== "" ? (
                                    <>
                                      <option value="">Please select the Party to the transaction</option>
                                      {transactionOptions[transactionId.represent]?.[`${selectedSide}Side`]?.map(
                                        ([stepNo, value, title]) => (
                                        
                                          <option key={value} value={`${stepNo}::${value}::${title}`}>
                                            {title}
                                          </option>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <option value="">Please select the Side First</option>
                                  )}
                                </select>
                                </div>

                                {
                                  contactBuyerOther === "other_buyer" ?
                                  <div className="mb-3">
                                   <label className="col-form-label">
                                    Add Other Type
                                   </label>
                                  <input
                                  className="form-control"
                                  id="inline-form-input"
                                  type="text"
                                  value={otherSideBuyer}
                                  onChange={handleInputBuyer}
                                /> 
                                </div> 
                                :""                             
                                }

                                {
                                  contactSellerOther === "seller_other" ?
                                  <div className="mb-3">
                                      <label className="col-form-label">
                                    Add Other Type
                                  </label>
                                  <input
                                  className="form-control"
                                  id="inline-form-input"
                                  type="text"
                                  value={otherSideValue}
                                  onChange={handleInputChange}
                                />  
                                  </div>
                                :""                             
                                }

                            <div className="pull-right mt-3">
                              {
                                contactTitle ?
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm  pull-left"
                                    onClick={selectContact}
                                  >
                                    Select Contact
                                  </button>
                                  :
                                <span className="btn btn-primary btn-sm  pull-left">Please select the Side and Party to the transaction.</span>
                              }
                              <button
                                type="button"
                                className="btn btn-default btn btn-secondary btn-sm ms-3"
                                id="closeModalp"
                                data-dismiss="modal"
                                onClick={Cancel}
                              >
                                Cancel & Close
                              </button>
                            </div>
                          </div>
                        )}
                        
                      </div>
                      <div className=" col-md-6 mt-2">
                        {isLoading ? (
                          ""
                        ) : (
                          <div className="">
                            {results && results.length > 0
                              ? results.map((post) => (
                                  <ul
                                    className="list-group"
                                    onClick={(e) =>
                                      handleSearchTransaction(post._id)
                                    }
                                  >
                                    <li className="list-group-item d-flex justify-content-start align-items-center mt-0">
                                      <img
                                        className="rounded-circle avtar"
                                        src={post.image || avtar}
                                        alt="Profile"
                                      />

                                      <span className="float-left text-left w-100 ms-2">
                                        {/* <img className="avtar" src={avtar} /> */}{" "}
                                        <strong>
                                          {post.firstName}
                                          {post.lastName}
                                        </strong>
                                        <br />
                                        {post.company}
                                        <br />
                                        {post.phone}
                                      </span>
                                    </li>
                                  </ul>
                                ))
                              : ""}
                          </div>
                        )}
                      </div>
                      {results && results.length > 0 ?  
                      <div className="pagination justify-content-end mb-0 mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center mb-0 mt-3"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                          activeClassName={"active"}
                        />
                      </div>
                      :""
                      }
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* <div className="modal in" role="dialog" id="invitecontact">
          <div
            className="modal-dialog modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Invite Contact</h4>
                <button
                  className="btn-close"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="closeModalinvite"
                ></button>
              </div>
              <div className="modal-body fs-sm">
                <div className="row">
                    <div className="col-md-6 mt-0 w-100">
                      <div className="mt-0">
                        <h4>Get the full value by inviting your clients.</h4>
                        <p>Upyour game and reap the rewards.</p>
                        <p>Invited clients will be able to :</p>
                        <span>View tasks and documents</span>
                        <span>Track progress</span>
                        <span>Refer more business</span>
                      </div>

                      <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-default btn btn-secondary btn-sm mt-2"
                          //id="closeModalinvite" 
                          data-dismiss="modal"
                        >
                          Cancel & Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm  pull-left mt-2"
                          onClick={sendContactinvite}
                        >
                          Send Email Invite
                        </button>
                      </div>
                    </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </main>
    </div>
  );
};

export default TransactionContact;